export const LOCAL_TRANSLATIONS = {
  en: {
    'language': 'Language',
    'wizard.common.stepIndicator': 'Step {{current}} of {{total}}',
    'wizard.common.previous': 'Previous',
    'wizard.language.title': 'Choose your preferred language',
    'wizard.language.subtitle': 'Select the language you are most comfortable with. You can switch anytime and we will send every document and follow-up in your chosen language.',
    'wizard.language.option.en.label': 'English',
    'wizard.language.option.en.native': 'English',
    'wizard.language.option.en.description': 'Guided experience in international English, suitable for visa documentation.',
    'wizard.language.option.en.badge': 'Recommended for documentation',
    'wizard.language.option.ta.label': 'Tamil',
    'wizard.language.option.ta.native': 'தமிழ்',
    'wizard.language.option.ta.description': 'நிகழ்வுகளை தமிழ் மொழியில் அனுபவிக்கலாம். ஆலோசகருடன் எளிதாக பேச உதவும்.',
    'wizard.language.option.ta.badge': 'தமிழ் வழிகாட்டல் ஆதரவு',
    'wizard.language.option.si.label': 'Sinhala',
    'wizard.language.option.si.native': 'සිංහල',
    'wizard.language.option.si.description': 'සිංහලෙන් සම්පූර්ණ මඟපෙන්වීම. ඔබගේ දුරකථන ඇමතුම් වලට උපකාරී වේ.',
    'wizard.language.option.si.badge': 'Sinhala support included',
    'wizard.language.tipTitle': 'Why we ask this first',
    'wizard.language.tip1': 'All future questions, reminders, and visa documents will appear in this language.',
    'wizard.language.tip2': 'Advisors review your answers and prepare consultation notes in your selected language.',
    'wizard.language.tip3': 'Switching the language later updates document templates and alerts instantly.',
    'wizard.language.next': 'Continue',
    'language': 'Language',
    'wizard.steps.language': 'Language',
    'wizard.steps.country': 'Country',
    'wizard.steps.personal': 'Personal',
    'wizard.steps.education': 'Education',
    'wizard.steps.experience': 'Experience',
    'wizard.steps.languageSkills': 'Language Skills',
    'wizard.steps.cvUpload': 'CV Upload',
    'wizard.steps.financial': 'Financial',
    'wizard.steps.review': 'Review',
    'wizard.steps.submit': 'Submit',
    'wizard.header.title': 'Lead Qualification Wizard',
    'wizard.header.subtitle': 'Find your best immigration pathway with our AI-powered qualification wizard. Answer a few questions about your background and preferences to get personalized recommendations.',
    'wizard.header.badgeTime': 'Complete in about 6 minutes',
    'wizard.header.badgeReview': 'Advisors review your answers before the call',
    'wizard.help.text': 'Need help? Contact our immigration specialists at',
    'wizard.help.email': 'info@ravanaindustries.com',
    'wizard.country.quickFacts.time.label': 'Average completion time',
    'wizard.country.quickFacts.time.value': '≈ 6 minutes',
    'wizard.country.quickFacts.time.description': 'Finish the wizard once and our advisors arrive prepared for your consultation.',
    'wizard.country.quickFacts.docs.label': 'Documentation saved',
    'wizard.country.quickFacts.docs.value': '30+ mins',
    'wizard.country.quickFacts.docs.description': 'We pre-fill onboarding paperwork using the answers you share right now.',
    'wizard.country.quickFacts.pathways.label': 'Personalised pathways',
    'wizard.country.quickFacts.pathways.value': '3 curated options',
    'wizard.country.quickFacts.pathways.description': 'Unlock tailored study or work routes for your profile before the first call.',
    'wizard.country.guidance.germany.title': 'What to expect for Germany',
    'wizard.country.guidance.germany.bullet1': 'English-taught Bachelor & Master programmes with €0 tuition at public universities.',
    'wizard.country.guidance.germany.bullet2': 'Chancenkarte and Skilled Worker pathways: points-based assessment with rapid job market support.',
    'wizard.country.guidance.germany.bullet3': 'Blocked account guidance and bank partners shared immediately after this step.',
    'wizard.country.guidance.canada.title': 'What to expect for Canada',
    'wizard.country.guidance.canada.bullet1': 'PG Diploma funding options with 25% upfront payment and 75% after arrival financing.',
    'wizard.country.guidance.canada.bullet2': 'PGWP timelines and province-specific admission windows included in your personalised pack.',
    'wizard.country.guidance.canada.bullet3': 'Work while studying roadmap with average earnings by province.',
    'wizard.country.guidance.uk.title': 'What to expect for the United Kingdom',
    'wizard.country.guidance.uk.bullet1': 'One-year Master programmes with Graduate Route extension details.',
    'wizard.country.guidance.uk.bullet2': 'Scholarship shortlists and CAS processing timelines prepared automatically.',
    'wizard.country.guidance.uk.bullet3': 'Visa success checklist covering maintenance funds and accommodation proof.',
    'wizard.country.guidance.notSure.title': 'Need help deciding?',
    'wizard.country.guidance.notSure.bullet1': 'Share your goals and we will compare success rates across Germany, Canada and the UK.',
    'wizard.country.guidance.notSure.bullet2': 'Get a career-aligned shortlist with time-to-visa and investment required.',
    'wizard.country.guidance.notSure.bullet3': 'Receive a prep pack covering language, budget, and documentation expectations.',
    'wizard.country.guidance.default.title': 'How we use your choice',
    'wizard.country.guidance.default.bullet1': 'We tailor every upcoming question to the immigration rules of the country you select.',
    'wizard.country.guidance.default.bullet2': 'Visa requirements, costs, and timelines are pre-loaded so you only see relevant guidance.',
    'wizard.country.guidance.default.bullet3': 'You can switch countries at any time before submission—your answers will update automatically.',
    'wizard.country.guidance.fallback.title': 'What to expect next',
    'wizard.country.guidance.fallback.bullet1': 'We summarise visa requirements, tuition or salary expectations, and next steps for your advisor.',
    'wizard.country.guidance.fallback.bullet2': 'You will receive downloadable preparation guides immediately after submission.',
    'wizard.country.guidance.fallback.bullet3': 'Our specialists review your profile before calling so you can jump straight into planning.',
    'wizard.personal.title': 'Personal Information',
    'wizard.personal.description': 'Tell us about yourself so we can provide personalized immigration guidance.',
    'wizard.personal.tipTitle': 'Why this matters now',
    'wizard.personal.tip1': 'We pre-fill offer letters and visa forms with the exact spelling you provide—double-check before continuing.',
    'wizard.personal.tip2': 'Sharing your contact preferences lets our advisors send you a readiness pack before the call, cutting the average conversation by 15 minutes.',
    'wizard.personal.tip3': 'Your nationality and current location determine embassy slots and biometric availability—we secure the fastest centre for you.',
    'wizard.personal.phoneHelper': 'Include your country code so we can reach you on WhatsApp or voice call without delays.',
    'wizard.personal.fields.firstName.label': 'First Name *',
    'wizard.personal.fields.firstName.placeholder': 'Enter your first name',
    'wizard.personal.fields.lastName.label': 'Last Name *',
    'wizard.personal.fields.lastName.placeholder': 'Enter your last name',
    'wizard.personal.fields.email.label': 'Email Address *',
    'wizard.personal.fields.email.placeholder': 'your.email@example.com',
    'wizard.personal.fields.phone.label': 'Phone Number *',
    'wizard.personal.fields.phone.placeholder': '+94 77 123 4567',
    'wizard.personal.fields.dateOfBirth.label': 'Date of Birth *',
    'wizard.personal.fields.dateOfBirth.helper': 'We use this to score age-based visa points and set reminders before eligibility thresholds.',
    'wizard.personal.fields.nationality.label': 'Nationality *',
    'wizard.personal.fields.nationality.placeholder': 'Select your nationality',
    'wizard.personal.fields.currentCountry.label': 'Current Country of Residence *',
    'wizard.personal.fields.currentCountry.placeholder': 'Select your current country',
    'wizard.personal.errors.firstName.required': 'First name is required',
    'wizard.personal.errors.firstName.min': 'First name must be at least {{min}} characters',
    'wizard.personal.errors.lastName.required': 'Last name is required',
    'wizard.personal.errors.lastName.min': 'Last name must be at least {{min}} characters',
    'wizard.personal.errors.email.required': 'Email is required',
    'wizard.personal.errors.email.invalid': 'Please enter a valid email address',
    'wizard.personal.errors.phone.required': 'Phone number is required',
    'wizard.personal.errors.phone.invalid': 'Please enter a valid phone number',
    'wizard.personal.errors.dateOfBirth.required': 'Date of birth is required',
    'wizard.personal.errors.dateOfBirth.range': 'Age must be between {{min}} and {{max}} years',
    'wizard.personal.errors.nationality.required': 'Nationality is required',
    'wizard.personal.errors.currentCountry.required': 'Current country is required',
    'wizard.education.title': 'Educational Background',
    'wizard.education.description': 'Tell us about your education so we can assess your eligibility for various immigration programs.',
    'wizard.education.errors.highestEducation.required': 'Please select your highest education level',
    'wizard.education.errors.fieldOfStudy.required': 'Please select your field of study',
    'wizard.education.errors.university.required': 'University/Institution name is required',
    'wizard.education.errors.graduationYear.required': 'Graduation year is required',
    'wizard.education.errors.graduationYear.invalid': 'Please enter a valid graduation year',
    'wizard.education.fields.highestEducation.label': 'Highest Education Level *',
    'wizard.education.fields.highestEducation.placeholder': 'Select your highest education',
    'wizard.education.fields.fieldOfStudy.label': 'Field of Study *',
    'wizard.education.fields.fieldOfStudy.placeholder': 'Select your field of study',
    'wizard.education.fields.university.label': 'University/Institution/School *',
    'wizard.education.fields.university.placeholder': 'Enter your university name',
    'wizard.education.fields.graduationYear.label': 'Graduation Year / A Level exam year *',
    'wizard.education.fields.graduationYear.placeholder': 'e.g., 2020',
    'wizard.education.fields.grades.label': 'Grades / GPA / Results (Optional)',
    'wizard.education.fields.grades.placeholder': 'e.g., 3.8 GPA, First Class Honors, A grades',
    'wizard.education.fields.grades.helper': 'This helps us assess your eligibility for merit-based programs',
    'wizard.education.fields.additionalCertificates.label': 'Additional Certifications (Optional)',
    'wizard.education.fields.additionalCertificates.placeholder': 'List any relevant professional certifications or additional qualifications',
    'wizard.education.fields.additionalCertificates.helper': 'Include professional licenses, certifications, or specialized training',
    'wizard.education.notice.title': 'Why this information matters',
    'wizard.education.notice.body': 'Your educational background helps us identify immigration programs that match your qualifications. Different countries have specific education requirements for various visa categories.',
    'wizard.education.levels.highSchool': 'High School / O-Levels',
    'wizard.education.levels.aLevels': 'A-Levels',
    'wizard.education.levels.diploma': 'Diploma',
    'wizard.education.levels.bachelors': 'Bachelor\'s Degree',
    'wizard.education.levels.masters': 'Master\'s Degree',
    'wizard.education.levels.phd': 'PhD / Doctorate',
    'wizard.education.levels.professionalCertification': 'Professional Certification',
    'wizard.education.levels.other': 'Other',
    'wizard.education.fields.engineering': 'Engineering',
    'wizard.education.fields.medicineHealthcare': 'Medicine / Healthcare',
    'wizard.education.fields.business': 'Business Administration',
    'wizard.education.fields.it': 'Computer Science / IT',
    'wizard.education.fields.naturalSciences': 'Natural Sciences',
    'wizard.education.fields.socialSciences': 'Social Sciences',
    'wizard.education.fields.artsHumanities': 'Arts & Humanities',
    'wizard.education.fields.law': 'Law',
    'wizard.education.fields.education': 'Education',
    'wizard.education.fields.agriculture': 'Agriculture',
    'wizard.education.fields.other': 'Other',
    'wizard.experience.title': 'Work Experience',
    'wizard.experience.description': 'Your professional experience can significantly impact your immigration eligibility and points calculation.',
    'wizard.experience.errors.totalExperience.required': 'Please select your total work experience',
    'wizard.experience.errors.hasInternationalExperience.required': 'Please select your international experience status',
    'wizard.experience.errors.jobTitle.required': 'Job title is required',
    'wizard.experience.errors.company.required': 'Company name is required',
    'wizard.experience.errors.industry.required': 'Please select your industry',
    'wizard.experience.errors.currentJobStatus.required': 'Please select your current job status',
    'wizard.experience.fields.totalExperience.label': 'Total Work Experience *',
    'wizard.experience.fields.totalExperience.placeholder': 'Select your experience',
    'wizard.experience.fields.hasInternationalExperience.label': 'International Work Experience *',
    'wizard.experience.fields.hasInternationalExperience.placeholder': 'Select international experience',
    'wizard.experience.fields.hasInternationalExperience.options.yes': 'Yes, I have international work experience',
    'wizard.experience.fields.hasInternationalExperience.options.no': 'No, I only worked in my home country',
    'wizard.experience.fields.jobTitle.label': 'Current/Most Recent Job Title *',
    'wizard.experience.fields.jobTitle.placeholder': 'e.g., Software Engineer, Marketing Manager',
    'wizard.experience.fields.company.label': 'Current/Most Recent Company *',
    'wizard.experience.fields.company.placeholder': 'Enter your company name',
    'wizard.experience.fields.industry.label': 'Industry *',
    'wizard.experience.fields.industry.placeholder': 'Select your industry',
    'wizard.experience.fields.currentJobStatus.label': 'Current Employment Status *',
    'wizard.experience.fields.currentJobStatus.placeholder': 'Select your status',
    'wizard.experience.fields.skills.label': 'Key Skills & Expertise (Optional)',
    'wizard.experience.fields.skills.placeholder': 'List your key professional skills, technical expertise, and specializations',
    'wizard.experience.fields.skills.helper': 'Include technical skills, software proficiency, languages, and professional certifications',
    'wizard.experience.notice.title': 'Experience matters for immigration',
    'wizard.experience.notice.body': 'Work experience is crucial for skilled worker immigration programs. International experience, specialized skills, and continuous employment history can significantly increase your eligibility.',
    'wizard.experience.levels.none': 'None',
    'wizard.experience.levels.lt1': 'Less than 1 year',
    'wizard.experience.levels.1to2': '1-2 years',
    'wizard.experience.levels.3to5': '3-5 years',
    'wizard.experience.levels.6to10': '6-10 years',
    'wizard.experience.levels.11to15': '11-15 years',
    'wizard.experience.levels.16to20': '16-20 years',
    'wizard.experience.levels.gt20': 'More than 20 years',
    'wizard.experience.industries.it': 'Information Technology',
    'wizard.experience.industries.healthcare': 'Healthcare',
    'wizard.experience.industries.engineering': 'Engineering',
    'wizard.experience.industries.finance': 'Finance & Banking',
    'wizard.experience.industries.education': 'Education',
    'wizard.experience.industries.salesMarketing': 'Sales & Marketing',
    'wizard.experience.industries.manufacturing': 'Manufacturing',
    'wizard.experience.industries.construction': 'Construction',
    'wizard.experience.industries.hospitality': 'Hospitality',
    'wizard.experience.industries.transportation': 'Transportation',
    'wizard.experience.industries.agriculture': 'Agriculture',
    'wizard.experience.industries.government': 'Government/Public Sector',
    'wizard.experience.industries.consulting': 'Consulting',
    'wizard.experience.industries.realEstate': 'Real Estate',
    'wizard.experience.industries.media': 'Media & Communications',
    'wizard.experience.industries.other': 'Other',
    'wizard.experience.jobStatus.employed': 'Currently Employed',
    'wizard.experience.jobStatus.selfEmployed': 'Self-Employed',
    'wizard.experience.jobStatus.unemployed': 'Unemployed',
    'wizard.experience.jobStatus.student': 'Student',
    'wizard.experience.jobStatus.freelancer': 'Freelancer',
    'wizard.experience.jobStatus.businessOwner': 'Business Owner',
    'wizard.experience.jobStatus.retired': 'Retired',
    'wizard.languageSkills.title': 'Language Skills',
    'wizard.languageSkills.description': 'Language proficiency is essential for immigration and significantly impacts your eligibility for various programs.',
    'wizard.languageSkills.errors.englishReading.required': 'Please select your English reading level',
    'wizard.languageSkills.errors.englishWriting.required': 'Please select your English writing level',
    'wizard.languageSkills.errors.englishSpeaking.required': 'Please select your English speaking level',
    'wizard.languageSkills.errors.englishListening.required': 'Please select your English listening level',
    'wizard.languageSkills.errors.hasIELTS.required': 'Please specify if you have IELTS results',
    'wizard.languageSkills.errors.ieltsScore.required': 'Please select your IELTS score',
    'wizard.languageSkills.section.englishProficiency.title': 'English Language Proficiency *',
    'wizard.languageSkills.section.tests.title': 'Standardized Test Scores',
    'wizard.languageSkills.fields.englishReading.label': 'Reading',
    'wizard.languageSkills.fields.englishReading.placeholder': 'Select reading level',
    'wizard.languageSkills.fields.englishWriting.label': 'Writing',
    'wizard.languageSkills.fields.englishWriting.placeholder': 'Select writing level',
    'wizard.languageSkills.fields.englishSpeaking.label': 'Speaking',
    'wizard.languageSkills.fields.englishSpeaking.placeholder': 'Select speaking level',
    'wizard.languageSkills.fields.englishListening.label': 'Listening',
    'wizard.languageSkills.fields.englishListening.placeholder': 'Select listening level',
    'wizard.languageSkills.fields.hasIELTS.label': 'Do you have IELTS results? *',
    'wizard.languageSkills.fields.hasIELTS.placeholder': 'Select IELTS status',
    'wizard.languageSkills.fields.hasIELTS.options.yes': 'Yes, I have IELTS results',
    'wizard.languageSkills.fields.hasIELTS.options.no': "No, I haven't taken IELTS",
    'wizard.languageSkills.fields.hasIELTS.options.planning': 'Planning to take it soon',
    'wizard.languageSkills.fields.ieltsScore.label': 'IELTS Overall Band Score *',
    'wizard.languageSkills.fields.ieltsScore.placeholder': 'Select IELTS score',
    'wizard.languageSkills.fields.ieltsScore.clbHint': '💡 Equivalent to CLB Level {{level}} for Canadian immigration',
    'wizard.languageSkills.fields.hasTOEFL.label': 'Do you have TOEFL results? (Optional)',
    'wizard.languageSkills.fields.hasTOEFL.placeholder': 'Select TOEFL status',
    'wizard.languageSkills.fields.hasTOEFL.options.yes': 'Yes, I have TOEFL results',
    'wizard.languageSkills.fields.hasTOEFL.options.no': "No, I haven't taken TOEFL",
    'wizard.languageSkills.fields.toeflScore.label': 'TOEFL Total Score',
    'wizard.languageSkills.fields.toeflScore.placeholder': 'Select TOEFL score',
    'wizard.languageSkills.fields.otherLanguages.label': 'Other Languages (Optional)',
    'wizard.languageSkills.fields.otherLanguages.placeholder': 'List any other languages you speak and your proficiency level',
    'wizard.languageSkills.fields.otherLanguages.helper': 'Include languages like French, German, Spanish, etc. which can be beneficial for immigration',
    'wizard.languageSkills.notice.title': 'Language requirements for immigration',
    'wizard.languageSkills.notice.body': 'Most immigration programs require minimum language proficiency. Standardized test scores like IELTS are often mandatory and directly impact your points calculation and eligibility.',
    'wizard.languageSkills.levels.beginner': 'Beginner (A1-A2)',
    'wizard.languageSkills.levels.intermediate': 'Intermediate (B1-B2)',
    'wizard.languageSkills.levels.advanced': 'Advanced (C1)',
    'wizard.languageSkills.levels.native': 'Native/Fluent (C2)',
    'wizard.languageSkills.ielts.4_0_4_5': '4.0 - 4.5 (Limited)',
    'wizard.languageSkills.ielts.5_0_5_5': '5.0 - 5.5 (Modest)',
    'wizard.languageSkills.ielts.6_0_6_5': '6.0 - 6.5 (Competent)',
    'wizard.languageSkills.ielts.7_0_7_5': '7.0 - 7.5 (Good)',
    'wizard.languageSkills.ielts.8_0_8_5': '8.0 - 8.5 (Very Good)',
    'wizard.languageSkills.ielts.9_0': '9.0 (Expert)',
    'wizard.languageSkills.toefl.0_30': '0-30 (Limited)',
    'wizard.languageSkills.toefl.31_50': '31-50 (Low Intermediate)',
    'wizard.languageSkills.toefl.51_70': '51-70 (Intermediate)',
    'wizard.languageSkills.toefl.71_90': '71-90 (High Intermediate)',
    'wizard.languageSkills.toefl.91_100': '91-100 (Advanced)',
    'wizard.languageSkills.toefl.101_120': '101-120 (Expert)',
    'wizard.financialInfo.title': 'Education Budget',
    'wizard.financialInfo.description': 'Understanding your available education budget helps us recommend the most suitable immigration pathways and financial options.',
    'wizard.financialInfo.errors.educationBudget.required': 'Please select your available education budget',
    'wizard.financialInfo.fields.currency.label': 'Preferred Currency',
    'wizard.financialInfo.fields.educationBudget.label': 'Available Education Budget *',
    'wizard.financialInfo.fields.educationBudget.placeholder': 'Select your education budget',
    'wizard.financialInfo.fields.financialNotes.label': 'Additional Financial Notes (Optional)',
    'wizard.financialInfo.fields.financialNotes.placeholder': 'Any additional information about your financial situation, scholarships, or funding sources',
    'wizard.financialInfo.fields.financialNotes.helper': 'Let us know if you have scholarships, family support, or other funding arrangements',
    'wizard.financialInfo.notice.title': 'Why your budget matters',
    'wizard.financialInfo.notice.body': 'Your education budget helps us recommend the most suitable immigration pathways. Different countries have varying costs: Germany requires a blocked account ({{symbol}}13,080/year), Canada requires proof of funds, and tuition fees vary significantly.',
    'wizard.financialInfo.currencies.usd': 'USD - US Dollar',
    'wizard.financialInfo.currencies.eur': 'EUR - Euro',
    'wizard.financialInfo.currencies.gbp': 'GBP - British Pound',
    'wizard.financialInfo.currencies.cad': 'CAD - Canadian Dollar',
    'wizard.financialInfo.currencies.aud': 'AUD - Australian Dollar',
    'wizard.financialInfo.currencies.lkr': 'LKR - Sri Lankan Rupee',
    'wizard.financialInfo.currencies.inr': 'INR - Indian Rupee',
    'wizard.financialInfo.budgets.0_10000': 'Under $10,000',
    'wizard.financialInfo.budgets.10000_25000': '$10,000 - $25,000',
    'wizard.financialInfo.budgets.25000_50000': '$25,000 - $50,000',
    'wizard.financialInfo.budgets.50000_75000': '$50,000 - $75,000',
    'wizard.financialInfo.budgets.75000_plus': 'Over $75,000',
    'wizard.review.recommendations.title': 'Recommended Immigration Options',
    'wizard.review.proceedButton': 'Proceed to Final Step',
    'wizard.submit.title': 'Submit Your Profile',
    'wizard.submit.description': 'Submit your complete profile to receive personalized immigration recommendations from our experts.',
    'wizard.submit.errors.agreeToTerms': 'Please agree to the terms and conditions to proceed.',
    'wizard.submit.actions.submitting': 'Submitting...',
    'wizard.submit.actions.submitForReview': 'Submit Profile for Review',
    'wizard.dynamic.title': 'Additional Questions',
    'wizard.dynamic.subtitle': 'These questions help us provide more personalized guidance for your immigration journey.',
    'wizard.dynamic.radioGroupLabel': 'Answer choices',
    'wizard.dynamic.questions.ielts_status.question': 'What is your IELTS status?',
    'wizard.dynamic.questions.ielts_status.options.have_6_0': 'Have 6.0+',
    'wizard.dynamic.questions.ielts_status.options.taking_soon': 'Taking Soon',
    'wizard.dynamic.questions.ielts_status.options.not_started': 'Not Started',
    'wizard.dynamic.questions.ielts_status.options.need_help': 'Need Help',
    'wizard.dynamic.questions.al_results.question': 'What are your A/L results?',
    'wizard.dynamic.questions.al_results.options.3_passes': '3 Passes',
    'wizard.dynamic.questions.al_results.options.2_passes': '2 Passes',
    'wizard.dynamic.questions.al_results.options.1_pass': '1 Pass',
    'wizard.dynamic.questions.al_results.options.still_waiting': 'Still Waiting',
    'wizard.dynamic.questions.program_interest.question': 'Which program interests you?',
    'wizard.dynamic.questions.program_interest.options.1_year_pg_certificate': '1-Year PG Certificate',
    'wizard.dynamic.questions.program_interest.options.2_year_pg_diploma': '2-Year PG Diploma',
    'wizard.dynamic.questions.program_interest.options.certificate': 'Certificate',
    'wizard.dynamic.questions.program_interest.options.diploma': 'Diploma',
    'wizard.dynamic.questions.program_interest.options.bachelor_master': 'Bachelor/Master',
    'wizard.dynamic.questions.program_interest.options.need_guidance': 'Need Guidance',
    'wizard.dynamic.questions.program_interest.options.bachelor_s_degree': 'Bachelor\'s Degree',
    'wizard.dynamic.questions.program_interest.options.master_s_degree': 'Master\'s Degree',
    'wizard.dynamic.questions.program_interest.options.graduate_diploma': 'Graduate Diploma',
    'wizard.dynamic.questions.program_interest.options.vocational_education': 'Vocational Education',
    'wizard.dynamic.questions.program_interest.options.phd': 'PhD',
    'wizard.dynamic.questions.program_interest.options.foundation_course': 'Foundation Course',
    'wizard.dynamic.questions.program_interest.options.associate_degree': 'Associate Degree',
    'wizard.financial.title': 'Financial Information for {{country}}',
    'wizard.financial.subtitle': 'Important cost information and financial requirements',
    'wizard.financial.tipTitle': 'Tip:',
    'wizard.financial.tipBody': 'These costs are estimates. Actual amounts may vary based on your specific situation and current exchange rates.',
    'wizard.financial.titles.blockedAccount': 'Blocked Account Requirement',
    'wizard.financial.titles.sponsorSavings': 'Sponsorship Benefits',
    'wizard.financial.titles.tuition': 'Tuition Fees',
    'wizard.financial.titles.loanOption': 'Payment Options',
    'wizard.financial.titles.costs': 'Estimated Costs',
    'wizard.financial.titles.workPermit': 'Work Rights',
    'wizard.financial.titles.workRights': 'Work Rights',
    'wizard.financial.titles.postStudy': 'Post-Study Opportunities',
    'wizard.financial.titles.guidance': 'Our Guidance',
    'wizard.financial.titles.comparison': 'Comparison Service',
    'wizard.financial.titles.support': 'Support Available',
    'wizard.financial.titles.budgetRange': 'Budget Planning',
    'wizard.submit.finalStep': 'Final Step',
    'wizard.insights.progress': 'Progress',
    'wizard.insights.complete': 'complete',
    'wizard.insights.mobileToggleTitle': 'Step guidance & preparation',
    'wizard.insights.expand': 'Tap to expand',
    'wizard.insights.collapse': 'Tap to collapse',
    'wizard.insights.fastTipTitle': 'Fast-track tip',
    'wizard.insights.fastTipBody': 'Complete the wizard in one sitting to receive your personalised "Immigration Readiness Pack" instantly. Most applicants who submit within a week secure a consultation slot within 48 hours.',
    'wizard.insights.snapshotTitle': 'Your snapshot so far',
    'wizard.insights.snapshot.notSelected': 'Not selected',
    'wizard.insights.snapshot.destination': 'Destination focus',
    'wizard.insights.snapshot.applicant': 'Applicant',
    'wizard.insights.snapshot.education': 'Highest qualification',
    'wizard.insights.snapshot.experience': 'Experience captured',
    'wizard.insights.snapshot.years': 'years',
    'wizard.insights.snapshot.language': 'Language status',
    'wizard.insights.nextTitle': 'Coming up next',
    'wizard.insights.nextDescription': 'Next you will focus on: {{title}}',
    'consult.chat.initialPrompt': 'Hello! I am your AI immigration consultant. Before we begin, which language would you prefer for this chat? (English / Tamil / Sinhala)',
    'consult.chat.resetPrompt': 'Hi again! Which language would you like to use today? (English / Tamil / Sinhala)',
    // Choice Page
    'choice.title': 'How Can We Help You Today?',
    'choice.subtitle': 'Choose the path that best fits your current needs. All paths lead to your dream of studying abroad!',
    'choice.option1.icon': '🎯',
    'choice.option1.title': 'Find Out Best Option for Me',
    'choice.option1.description': 'Not sure which country or program suits you best? Take our smart assessment to get personalized recommendations based on your profile, budget, and goals.',
    'choice.option1.feature1': 'AI-powered country matching',
    'choice.option1.feature2': 'Budget analysis & planning',
    'choice.option1.feature3': 'Career path recommendations',
    'choice.option1.feature4': 'Instant eligibility check',
    'choice.option1.cta': 'Start Free Assessment',
    'choice.option1.badge': 'RECOMMENDED',
    'choice.option2.icon': '💬',
    'choice.option2.title': 'I Know What I Want - Talk to Expert',
    'choice.option2.description': 'Already decided on your destination and program? Connect directly with our migration experts for personalized guidance and fast-track your application process.',
    'choice.option2.feature1': 'Direct expert consultation',
    'choice.option2.feature2': 'Application fast-tracking',
    'choice.option2.feature3': 'Document preparation help',
    'choice.option2.feature4': 'Visa interview coaching',
    'choice.option2.cta': 'Contact Expert Now',
    'choice.option3.icon': '📚',
    'choice.option3.title': 'I Just Need Information',
    'choice.option3.description': 'Want to explore your options and learn more? Chat with our AI assistant to get instant answers about programs, costs, requirements, and processes for all 5 countries.',
    'choice.option3.feature1': '24/7 AI assistant availability',
    'choice.option3.feature2': 'Instant answers to FAQs',
    'choice.option3.feature3': 'Program comparisons',
    'choice.option3.feature4': 'Cost breakdowns',
    'choice.option3.cta': 'Chat with AI Assistant',
    'choice.trust.title': 'Why 1000+ Students Trust Ravana Migration',
    'choice.trust.stat1.value': '99%',
    'choice.trust.stat1.label': 'Success Rate',
    'choice.trust.stat2.value': '5',
    'choice.trust.stat2.label': 'Countries',
    'choice.trust.stat3.value': '7+',
    'choice.trust.stat3.label': 'Years Experience',
    'choice.trust.stat4.value': '1000+',
    'choice.trust.stat4.label': 'Students Helped',
    'choice.trust.stat5.value': '100%',
    'choice.trust.stat5.label': 'Transparent',
    'choice.help.text': 'Still not sure which option is right for you?',
    'choice.help.link1': 'Learn More About Us',
    'choice.help.link2': 'View Our Packages',
    'choice.help.link3': 'Explore Services',
    // Home Page
    'home.ravana.global.track.title': 'Flight Plan™ Alliance Partner — One Profile. Five Destinations.',
    'home.ravana.global.track.subtitle': 'One partner. Five countries. Unlimited possibilities.',
    'home.ravana.global.track.description': 'Comprehensive visa and migration services across Germany, Canada, Australia, the United Kingdom, and New Zealand.',
    'home.hero.tagline': 'Study, Work & Settle Abroad — One Partner. Five Countries.',
    'home.why.choose.title': 'Why Choose Ravana Migration?',
    'home.cta.journey': 'Ready to Start Your Journey?',
    'home.cta.chat.expert': 'Chat with Expert',
    'home.cta.start.assessment': 'Start Free Assessment',
    // Services Page
    'services.hero.title': 'Flight Plan™ Alliance Partner Services',
    'services.hero.subtitle': 'One partner. Five countries. Unlimited possibilities.',
    'services.hero.description': 'Comprehensive visa and migration services across Germany, Canada, Australia, the United Kingdom, and New Zealand.',
    'services.why.choose.title': 'Why Choose Our Services?',
    'services.why.choose.subtitle': 'Trusted by students worldwide',
    'services.additional.title': 'Additional Support Services',
    'services.additional.subtitle': 'Comprehensive support services included with all our packages',
    'services.cta.journey': 'Ready to Start Your Journey?',
    'services.cta.contact': 'Contact Us',
    // About Page
    'about.cta.journey': 'Ready to Start Your Journey?',
    'about.cta.consultation': 'Book Free Consultation',
    // Global Branding
    'global.tagline': 'One Application. Five Destinations. One Global Partner.',
    'global.track.name': 'Flight Plan™ Alliance',
    'global.countries': 'Germany • Canada • Australia • United Kingdom • New Zealand',
    // Country Names
    'country.germany': 'Germany',
    'country.canada': 'Canada',
    'country.australia': 'Australia',
    'country.uk': 'United Kingdom',
    'country.newzealand': 'New Zealand',
    // Common Actions
    'common.get.started': 'Get Started',
    'common.learn.more': 'Learn More',
    'common.contact.us': 'Contact Us',
    'common.book.consultation': 'Book Consultation',
    'common.start.assessment': 'Start Assessment',
    'common.chat.expert': 'Chat with Expert'
  },
  ta: {
    'wizard.common.stepIndicator': 'படி {{current}} / {{total}}',
    'wizard.common.previous': 'முன் செல்ல',
    'wizard.language.title': 'உங்களுக்கு விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்',
    'wizard.language.subtitle': 'உங்களுக்கு வசதியாக இருக்கும் மொழியைத் தேர்வு செய்யுங்கள். எந்த நேரத்திலும் மாற்றலாம்; உங்கள் ஆவணங்களும் மடல்களும் அதே மொழியில் வரும்.',
    'wizard.language.option.en.label': 'ஆங்கிலம்',
    'wizard.language.option.en.native': 'English',
    'wizard.language.option.en.description': 'விசா ஆவணங்களுக்குப் பொருத்தமான சர்வதேச ஆங்கில வழிகாட்டல்.',
    'wizard.language.option.en.badge': 'ஆவணங்களுக்கு பரிந்துரைக்கப்படுகிறது',
    'wizard.language.option.ta.label': 'தமிழ்',
    'wizard.language.option.ta.native': 'தமிழ்',
    'wizard.language.option.ta.description': 'அனைத்து வழிகாட்டுதலையும் தமிழில் பெறுங்கள். ஆலோசகருடன் பேச எளிதாக இருக்கும்.',
    'wizard.language.option.ta.badge': 'தமிழ் ஆதரவு உள்ளது',
    'wizard.language.option.si.label': 'සිංහල',
    'wizard.language.option.si.native': 'සිංහල',
    'wizard.language.option.si.description': 'සිංහලෙන් මඟපෙන්වීම ලබා ගන්න. නියමිත දුරකථන ඇමතුම් සඳහා පහසුයි.',
    'wizard.language.option.si.badge': 'සිංහල සහාය',
    'wizard.language.tipTitle': 'ஏன் முதலில் இதைக் கேட்கிறோம்',
    'wizard.language.tip1': 'அடுத்த கேள்விகள், நினைவூட்டல்கள், விசா ஆவணங்கள் அனைத்தும் இந்த மொழியிலேயே வரும்.',
    'wizard.language.tip2': 'நீங்கள் தேர்ந்தெடுத்த மொழியிலேயே ஆலோசகர்கள் உங்கள் பதில்களைப் பார்வையிட்டு குறிப்புகளைத் தயார் செய்கிறார்கள்.',
    'wizard.language.tip3': 'மொழியை பின்னர் மாற்றினால் ஆவண வார்ப்புருக்கள் மற்றும் எச்சரிக்கைகள் உடனே புதுப்பிக்கப்படும்.',
    'wizard.language.next': 'தொடரவும்',
    'wizard.steps.language': 'மொழி',
    'wizard.steps.country': 'நாடு',
    'wizard.steps.personal': 'தனிப்பட்ட விவரங்கள்',
    'wizard.steps.education': 'கல்வி',
    'wizard.steps.experience': 'பணி அனுபவம்',
    'wizard.steps.languageSkills': 'மொழி திறன்கள்',
    'wizard.steps.cvUpload': 'CV பதிவேற்றம்',
    'wizard.steps.financial': 'நிதி',
    'wizard.steps.review': 'சரிபார்க்க',
    'wizard.steps.submit': 'சமர்ப்பிக்க',
    'wizard.header.title': 'இம்மிக்ரேஷன் வழிகாட்டி விஸார்டு',
    'wizard.header.subtitle': 'எங்களது AI வழிகாட்டியைப் பயன்படுத்தி உகந்த குடியேற்ற பாதையை கண்டுபிடிக்கவும். சில முக்கியமான கேள்விகளுக்கு பதில் அளித்து உங்கள் சுயவிவரத்திற்கு ஏற்ற பரிந்துரைகளைப் பெறுங்கள்.',
    'wizard.header.badgeTime': 'கிட்டத்தட்ட 6 நிமிடங்களில் நிறைவு',
    'wizard.header.badgeReview': 'உங்கள் பதில்களை ஆலோசகர்கள் முன்கூட்டியே ஆய்வு செய்கிறார்கள்',
    'wizard.help.text': 'உதவி தேவையா? எங்கள் குடியேற்ற நிபுணர்களை தொடர்பு கொள்ளுங்கள்:',
    'wizard.help.email': 'info@ravanaindustries.com',
    'wizard.country.quickFacts.time.label': 'நிறைவு நேரம்',
    'wizard.country.quickFacts.time.value': '≈ 6 நிமிடங்கள்',
    'wizard.country.quickFacts.time.description': 'ஒரே தடவையில் முடித்தால் ஆலோசர்கள் தயாராக வருவர்.',
    'wizard.country.quickFacts.docs.label': 'ஆவண நேரம் சேமிப்பு',
    'wizard.country.quickFacts.docs.value': '30+ நிமிடங்கள்',
    'wizard.country.quickFacts.docs.description': 'நீங்கள் அளித்த பதில்கள் மூலம் ஆவணங்களை முன்கூட்டியே நிரப்புவோம்.',
    'wizard.country.quickFacts.pathways.label': 'தனிப்பட்ட பாதைகள்',
    'wizard.country.quickFacts.pathways.value': '3 விருப்பங்கள்',
    'wizard.country.quickFacts.pathways.description': 'உங்கள் சுயவிவரத்திற்கு ஏற்ற படிப்பு/வேலை பாதைகள் திறக்கப்படும்.',
    'wizard.country.guidance.germany.title': 'ஜெர்மனியில் என்ன எதிர்பார்க்கலாம்',
    'wizard.country.guidance.germany.bullet1': 'அரசுப் பல்கலைக்கழகங்களில் €0 கட்டணத்துடன் ஆங்கிலத்தில் நடத்தப்படும் பட்ட மற்றும் முதுநிலை பாடத்திட்டங்கள்.',
    'wizard.country.guidance.germany.bullet2': 'Chancenkarte மற்றும் திறமையான தொழிலாளர் பாதைகள்: மதிப்பெண் அடிப்படையிலான மதிப்பீட்டுடன் வேகமான வேலை சந்தை ஆதரவு.',
    'wizard.country.guidance.germany.bullet3': 'இந்த படிநிலைக்குப் பிறகு தடை கணக்கு வழிகாட்டுதல் மற்றும் வங்கி கூட்டாளிகள் உடனடியாக பகிரப்படுகின்றன.',
    'wizard.country.guidance.canada.title': 'கனடாவில் என்ன எதிர்பார்க்கலாம்',
    'wizard.country.guidance.canada.bullet1': 'PG Diploma நிதி விருப்பங்கள்: 25% முன்கூட்டியே, 75% வருகைக்கு பின் நிதி ஏற்பாடு.',
    'wizard.country.guidance.canada.bullet2': 'PGWP கால அட்டவணைகள் மற்றும் மாகாண சேர்க்கை சாளரங்கள் உங்கள் தனிப்பட்ட தொகுப்பில் சேர்க்கப்பட்டிருக்கும்.',
    'wizard.country.guidance.canada.bullet3': 'ஒவ்வொரு மாகாணத்திலும் சராசரி வருமானத்துடன் படிக்கும் போது வேலை செய்யும் திட்ட வரைபடம்.',
    'wizard.country.guidance.uk.title': 'ஐக்கிய இராச்சியத்தில் என்ன எதிர்பார்க்கலாம்',
    'wizard.country.guidance.uk.bullet1': 'ஒரு ஆண்டு முதுநிலை பாடத்திட்டங்கள் மற்றும் Graduate Route நீட்டிப்பு விவரங்கள்.',
    'wizard.country.guidance.uk.bullet2': 'உதவித்தொகை குறுங்கட்டப் பட்டியல் மற்றும் CAS செயலாக்க காலஅட்டவணைகள் தானாகத் தயாராகும்.',
    'wizard.country.guidance.uk.bullet3': 'விசா வெற்றிக்கான சரிபார்ப்பு பட்டியல்; பராமரிப்பு நிதி மற்றும் தங்குமிடம் ஆதாரம் உட்பட.',
    'wizard.country.guidance.notSure.title': 'முடிவு செய்ய உதவி வேண்டுமா?',
    'wizard.country.guidance.notSure.bullet1': 'உங்கள் இலக்குகளைப் பகிருங்கள்; ஜெர்மனி, கனடா, UK வெற்றிவிகிதங்களை நாங்கள் ஒப்பிடுவோம்.',
    'wizard.country.guidance.notSure.bullet2': 'விசா காலஅட்டவணை மற்றும் முதலீட்டு தேவையுடன் தொழில் சார்ந்த குறுங்கட்டப் பட்டியல் கிடைக்கும்.',
    'wizard.country.guidance.notSure.bullet3': 'மொழி, பட்ஜெட், ஆவணங்களுக்கான தயாரிப்பு தொகுப்பைப் பெறுங்கள்.',
    'wizard.country.guidance.fallback.title': 'அடுத்ததாக என்ன நடக்கும்',
    'wizard.country.guidance.fallback.bullet1': 'விசா தேவைகள், கட்டணம் அல்லது சம்பள எதிர்பார்ப்புகள் மற்றும் ஆலோசகருக்கான அடுத்த படிகளை நாங்கள் சுருக்கமாக வழங்குகிறோம்.',
    'wizard.country.guidance.fallback.bullet2': 'சமர்ப்பித்தவுடன் உடனடியாக பதிவிறக்கக்கூடிய தயாரிப்பு வழிகாட்டிகள் கிடைக்கும்.',
    'wizard.country.guidance.fallback.bullet3': 'எங்கள் நிபுணர்கள் அழைப்பிற்கு முன் உங்கள் சுயவிவரத்தை ஆய்வு செய்வதால் திட்டமிடலை நேரடியாகத் தொடங்கலாம்.',
    'wizard.country.guidance.default.title': 'உங்கள் தேர்வை எவ்வாறு பயன்படுத்துகிறோம்',
    'wizard.country.guidance.default.bullet1': 'நீங்கள் தேர்ந்தெடுத்த நாட்டின் விதிமுறைகளுக்கு ஏற்ப அடுத்த கேள்விகள் தயார் செய்யப்படும்.',
    'wizard.country.guidance.default.bullet2': 'விசா தேவை, செலவுகள், காலக்கெடுகள் முன்கூட்டியே ஏற்றப்பட்டிருக்கும்.',
    'wizard.country.guidance.default.bullet3': 'சமர்ப்பிப்பதற்கு முன் எந்த நேரத்திலும் நாடு மாற்றலாம்; பதில்கள் தானாகப் புதுப்பிக்கப்படும்.',
    'wizard.personal.title': 'தனிப்பட்ட தகவல்கள்',
    'wizard.personal.description': 'உங்களைப் பற்றி கூறுங்கள்; உங்கள் குடியேற்ற பயணத்திற்கு தகுந்த வழிகாட்டுதலை வழங்க முடியும்.',
    'wizard.personal.tipTitle': 'ஏன் இப்போது முக்கியம்',
    'wizard.personal.tip1': 'உங்கள் பெயர்/விவரங்களின் எழுத்துப் பிழையின்றி ஆவணங்கள் தயார் செய்யப்படும்.',
    'wizard.personal.tip2': 'உங்கள் தொடர்பு விருப்பங்களை பகிர்ந்தால் ஆலோசனை அழைப்புக்குக் முன்பே தயாரிப்பு தொகுப்பை அனுப்ப முடியும்.',
    'wizard.personal.tip3': 'உங்கள் நாட்டினம், இருப்பிடம் ஆகியவை தூதரக நேரங்களை நிர்ணயிக்கும்—நாங்கள் வேகமான இடத்தை முன்பதிவு செய்கிறோம்.',
    'wizard.personal.phoneHelper': 'உங்கள் நாட்டுக் குறியீட்டுடன் சேர்க்கவும்; WhatsApp அல்லது அழைப்புக்கு எளிதில் தொடர்பு கொள்ள முடியும்.',
    'wizard.personal.fields.firstName.label': 'முதல் பெயர் *',
    'wizard.personal.fields.firstName.placeholder': 'உங்கள் முதல் பெயரை உள்ளிடவும்',
    'wizard.personal.fields.lastName.label': 'கடைசி பெயர் *',
    'wizard.personal.fields.lastName.placeholder': 'உங்கள் கடைசி பெயரை உள்ளிடவும்',
    'wizard.personal.fields.email.label': 'மின்னஞ்சல் முகவரி *',
    'wizard.personal.fields.email.placeholder': 'your.email@example.com',
    'wizard.personal.fields.phone.label': 'தொலைபேசி எண் *',
    'wizard.personal.fields.phone.placeholder': '+94 77 123 4567',
    'wizard.personal.fields.dateOfBirth.label': 'பிறந்த தேதி *',
    'wizard.personal.fields.dateOfBirth.helper': 'வயது அடிப்படையிலான விசா புள்ளிகளை மதிப்பிட இதைப் பயன்படுத்துகிறோம்; தகுதி எல்லைகளுக்கு முன் நினைவூட்டல்கள் அனுப்புவோம்.',
    'wizard.personal.fields.nationality.label': 'தேசியம் *',
    'wizard.personal.fields.nationality.placeholder': 'உங்கள் தேசியத்தைத் தேர்ந்தெடுக்கவும்',
    'wizard.personal.fields.currentCountry.label': 'தற்போது வசிக்கும் நாடு *',
    'wizard.personal.fields.currentCountry.placeholder': 'தற்போது வசிக்கும் நாட்டைத் தேர்ந்தெடுக்கவும்',
    'wizard.personal.errors.firstName.required': 'முதல் பெயர் அவசியம்',
    'wizard.personal.errors.firstName.min': 'முதல் பெயர் குறைந்தது {{min}} எழுத்துகள் இருக்க வேண்டும்',
    'wizard.personal.errors.lastName.required': 'கடைசி பெயர் அவசியம்',
    'wizard.personal.errors.lastName.min': 'கடைசி பெயர் குறைந்தது {{min}} எழுத்துகள் இருக்க வேண்டும்',
    'wizard.personal.errors.email.required': 'மின்னஞ்சல் முகவரி அவசியம்',
    'wizard.personal.errors.email.invalid': 'சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்',
    'wizard.personal.errors.phone.required': 'தொலைபேசி எண் அவசியம்',
    'wizard.personal.errors.phone.invalid': 'சரியான தொலைபேசி எண்ணை உள்ளிடவும்',
    'wizard.personal.errors.dateOfBirth.required': 'பிறந்த தேதி அவசியம்',
    'wizard.personal.errors.dateOfBirth.range': 'வயது {{min}} மற்றும் {{max}} ஆண்டுகளுக்கு இடையில் இருக்க வேண்டும்',
    'wizard.personal.errors.nationality.required': 'தேசியத்தைத் தேர்ந்தெடுக்கவும்',
    'wizard.personal.errors.currentCountry.required': 'தற்போது வசிக்கும் நாட்டைத் தேர்ந்தெடுக்கவும்',
    'wizard.education.title': 'கல்வி பின்னணி',
    'wizard.education.description': 'உங்கள் கல்வி விவரங்களைப் பகிருங்கள்; பல்வேறு குடியேற்ற திட்டங்களுக்கான தகுதியை சரியாக மதிப்பிட முடியும்.',
    'wizard.education.errors.highestEducation.required': 'உங்கள் உயர்ந்த கல்வி நிலையைக் தேர்ந்தெடுக்கவும்',
    'wizard.education.errors.fieldOfStudy.required': 'படிப்பு துறையைத் தேர்ந்தெடுக்கவும்',
    'wizard.education.errors.university.required': 'பல்கலைக்கழகம்/நிறுவனம் பெயர் அவசியம்',
    'wizard.education.errors.graduationYear.required': 'பட்டம் பெற்ற ஆண்டு அவசியம்',
    'wizard.education.errors.graduationYear.invalid': 'சரியான பட்டம் பெற்ற ஆண்டை உள்ளிடவும்',
    'wizard.education.fields.highestEducation.label': 'உயர்ந்த கல்வி நிலை *',
    'wizard.education.fields.highestEducation.placeholder': 'உங்கள் உயர்ந்த கல்வியைத் தேர்ந்தெடுக்கவும்',
    'wizard.education.fields.fieldOfStudy.label': 'படிப்பு துறை *',
    'wizard.education.fields.fieldOfStudy.placeholder': 'உங்கள் படிப்பு துறையைத் தேர்ந்தெடுக்கவும்',
    'wizard.education.fields.university.label': 'பல்கலைக்கழகம் / நிறுவனம் / பள்ளிகை *',
    'wizard.education.fields.university.placeholder': 'உங்கள் பல்கலைக்கழகத்தின் பெயரை உள்ளிடவும்',
    'wizard.education.fields.graduationYear.label': 'பட்டம் பெற்ற ஆண்டு / A Level தேர்வு ஆண்டு *',
    'wizard.education.fields.graduationYear.placeholder': 'உதா., 2020',
    'wizard.education.fields.grades.label': 'மதிப்பெண்கள் / GPA / முடிவுகள் (விருப்பம்)',
    'wizard.education.fields.grades.placeholder': 'உதா., 3.8 GPA, முதல் வகுப்பு கௌரவம், A மதிப்பெண்கள்',
    'wizard.education.fields.grades.helper': 'தகுதி அடிப்படையிலான திட்டங்களுக்கு உங்களை மதிப்பிட இது உதவுகிறது',
    'wizard.education.fields.additionalCertificates.label': 'கூடுதல் சான்றிதழ்கள் (விருப்பம்)',
    'wizard.education.fields.additionalCertificates.placeholder': 'தொடர்புடைய தொழில்முறை சான்றிதழ்கள் அல்லது கூடுதல் தகுதிகளை பட்டியலிடவும்',
    'wizard.education.fields.additionalCertificates.helper': 'தொழில்முறை உரிமங்கள், சான்றிதழ்கள் அல்லது சிறப்பு பயிற்சிகளை சேர்க்கவும்',
    'wizard.education.notice.title': 'இந்த தகவல் ஏன் முக்கியம்',
    'wizard.education.notice.body': 'உங்கள் கல்விப் பின்னணி உங்கள் தகுதிகளுக்கு ஏற்ற குடியேற்ற திட்டங்களை அடையாளம் காண உதவுகிறது. ஒவ்வொரு நாட்டிலும் விசா வகைகளுக்கு தனிப்பட்ட கல்வி தேவைகள் உள்ளன.',
    'wizard.education.levels.highSchool': 'மேல்நிலை / O-லெவல்ஸ்',
    'wizard.education.levels.aLevels': 'A-லெவல்ஸ்',
    'wizard.education.levels.diploma': 'டிப்ளமா',
    'wizard.education.levels.bachelors': 'இளங்கலை பட்டம்',
    'wizard.education.levels.masters': 'முதுகலை பட்டம்',
    'wizard.education.levels.phd': 'பிஎச்.டி / டாக்டரேட்',
    'wizard.education.levels.professionalCertification': 'தொழில்முறை சான்றிதழ்',
    'wizard.education.levels.other': 'மற்றவை',
    'wizard.education.fields.engineering': 'பொறியியல்',
    'wizard.education.fields.medicineHealthcare': 'மருத்துவம் / சுகாதாரம்',
    'wizard.education.fields.business': 'வணிக மேலாண்மை',
    'wizard.education.fields.it': 'கணினி அறிவியல் / ஐடி',
    'wizard.education.fields.naturalSciences': 'இயற்கை அறிவியல்',
    'wizard.education.fields.socialSciences': 'சமூக அறிவியல்',
    'wizard.education.fields.artsHumanities': 'கலை & மனிதவியல்',
    'wizard.education.fields.law': 'சட்டம்',
    'wizard.education.fields.education': 'கல்வி',
    'wizard.education.fields.agriculture': 'விவசாயம்',
    'wizard.education.fields.other': 'மற்றவை',
    'wizard.experience.title': 'பணி அனுபவம்',
    'wizard.experience.description': 'உங்கள் தொழில் அனுபவம் குடியேற்ற தகுதி மற்றும் புள்ளி கணக்கீட்டில் குறிப்பிடத்தக்க தாக்கம் ஏற்படுத்தும்.',
    'wizard.experience.errors.totalExperience.required': 'மொத்த பணி அனுபவத்தைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.errors.hasInternationalExperience.required': 'உங்கள் சர்வதேச அனுபவ நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.errors.jobTitle.required': 'பணி பதவி அவசியம்',
    'wizard.experience.errors.company.required': 'நிறுவனத்தின் பெயர் அவசியம்',
    'wizard.experience.errors.industry.required': 'உங்கள் தொழில் துறையைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.errors.currentJobStatus.required': 'தற்போதைய பணிநிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.fields.totalExperience.label': 'மொத்த பணி அனுபவம் *',
    'wizard.experience.fields.totalExperience.placeholder': 'உங்கள் அனுபவத்தைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.fields.hasInternationalExperience.label': 'சர்வதேச பணி அனுபவம் *',
    'wizard.experience.fields.hasInternationalExperience.placeholder': 'சர்வதேச அனுபவத்தைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.fields.hasInternationalExperience.options.yes': 'ஆம், எனக்கு சர்வதேச பணி அனுபவம் உள்ளது',
    'wizard.experience.fields.hasInternationalExperience.options.no': 'இல்லை, நான் என் சொந்த நாட்டில் மட்டும் பணிபுரிந்தேன்',
    'wizard.experience.fields.jobTitle.label': 'தற்போதைய/சமீபத்திய பணி பதவி *',
    'wizard.experience.fields.jobTitle.placeholder': 'உதா., மென்பொருள் பொறியாளர், மார்க்கெட்டிங் மேலாளர்',
    'wizard.experience.fields.company.label': 'தற்போதைய/சமீபத்திய நிறுவனம் *',
    'wizard.experience.fields.company.placeholder': 'உங்கள் நிறுவனப் பெயரை உள்ளிடவும்',
    'wizard.experience.fields.industry.label': 'தொழில் துறை *',
    'wizard.experience.fields.industry.placeholder': 'உங்கள் தொழில் துறையைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.fields.currentJobStatus.label': 'தற்போதைய பணிநிலை *',
    'wizard.experience.fields.currentJobStatus.placeholder': 'உங்கள் நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.experience.fields.skills.label': 'முக்கிய திறன்கள் & நிபுணத்துவம் (விருப்பம்)',
    'wizard.experience.fields.skills.placeholder': 'உங்கள் முக்கிய தொழில்முறை திறன்கள், தொழில்நுட்ப நிபுணத்துவம், சிறப்பு துறைகளை பட்டியலிடவும்',
    'wizard.experience.fields.skills.helper': 'தொழில்நுட்ப திறன்கள், மென்பொருள் தேர்ச்சிகள், மொழிகள், தொழில்முறை சான்றிதழ்கள் ஆகியவற்றைச் சேர்க்கவும்',
    'wizard.experience.notice.title': 'குடியேற்றத்திற்கு அனுபவம் முக்கியம்',
    'wizard.experience.notice.body': 'திறமையான தொழிலாளர் குடியேற்ற திட்டங்களுக்கு பணி அனுபவம் அத்தியாவசியம். சர்வதேச அனுபவம், சிறப்பு திறன்கள், தொடர்ச்சியான பணிநிலை வரலாறு ஆகியவை உங்கள் தகுதியை பெரிதும் உயர்த்துகின்றன.',
    'wizard.experience.levels.none': 'இல்லை',
    'wizard.experience.levels.lt1': '1 ஆண்டிற்கு குறைவானது',
    'wizard.experience.levels.1to2': '1-2 ஆண்டுகள்',
    'wizard.experience.levels.3to5': '3-5 ஆண்டுகள்',
    'wizard.experience.levels.6to10': '6-10 ஆண்டுகள்',
    'wizard.experience.levels.11to15': '11-15 ஆண்டுகள்',
    'wizard.experience.levels.16to20': '16-20 ஆண்டுகள்',
    'wizard.experience.levels.gt20': '20 ஆண்டுகளுக்கு மேல்',
    'wizard.experience.industries.it': 'தகவல் தொழில்நுட்பம்',
    'wizard.experience.industries.healthcare': 'சுகாதாரம்',
    'wizard.experience.industries.engineering': 'பொறியியல்',
    'wizard.experience.industries.finance': 'நிதி & வங்கி',
    'wizard.experience.industries.education': 'கல்வி',
    'wizard.experience.industries.salesMarketing': 'விற்பனை & சந்தைப்படுத்தல்',
    'wizard.experience.industries.manufacturing': 'உற்பத்தி',
    'wizard.experience.industries.construction': 'கட்டுமானம்',
    'wizard.experience.industries.hospitality': 'விருந்தோம்பல்',
    'wizard.experience.industries.transportation': 'போக்குவரத்து',
    'wizard.experience.industries.agriculture': 'விவசாயம்',
    'wizard.experience.industries.government': 'அரசு/பொது துறை',
    'wizard.experience.industries.consulting': 'ஆலோசனை',
    'wizard.experience.industries.realEstate': 'அசைவு சொத்து',
    'wizard.experience.industries.media': 'ஊடகம் & தொடர்பாடல்',
    'wizard.experience.industries.other': 'மற்றவை',
    'wizard.experience.jobStatus.employed': 'தற்போது வேலை செய்கிறேன்',
    'wizard.experience.jobStatus.selfEmployed': 'சுயதொழில்',
    'wizard.experience.jobStatus.unemployed': 'வேலை இல்லை',
    'wizard.experience.jobStatus.student': 'மாணவர்',
    'wizard.experience.jobStatus.freelancer': 'ஃப்ரீலான்சர்',
    'wizard.experience.jobStatus.businessOwner': 'தொழில் உரிமையாளர்',
    'wizard.experience.jobStatus.retired': 'ஓய்வு பெற்றவர்',
    'wizard.languageSkills.title': 'மொழித் திறன்கள்',
    'wizard.languageSkills.description': 'மொழித் திறன் குடியேற்றத்தில் அத்தியாவசியமானது மற்றும் பல்வேறு திட்டங்களுக்கு உங்கள் தகுதியை பெரிதும் பாதிக்கிறது.',
    'wizard.languageSkills.errors.englishReading.required': 'ஆங்கில வாசிப்பு நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.errors.englishWriting.required': 'ஆங்கில எழுத்து நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.errors.englishSpeaking.required': 'ஆங்கில பேச்சுத் திறனைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.errors.englishListening.required': 'ஆங்கில கேள்வி நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.errors.hasIELTS.required': 'உங்களிடம் IELTS முடிவு உள்ளதா என்பதை தெரிவுசெய்க',
    'wizard.languageSkills.errors.ieltsScore.required': 'உங்கள் IELTS மதிப்பெண்களைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.section.englishProficiency.title': 'ஆங்கில மொழித் திறன் *',
    'wizard.languageSkills.section.tests.title': 'தரநிலைத் தேர்வு மதிப்பெண்கள்',
    'wizard.languageSkills.fields.englishReading.label': 'வாசிப்பு',
    'wizard.languageSkills.fields.englishReading.placeholder': 'நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.englishWriting.label': 'எழுத்து',
    'wizard.languageSkills.fields.englishWriting.placeholder': 'நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.englishSpeaking.label': 'பேச்சு',
    'wizard.languageSkills.fields.englishSpeaking.placeholder': 'நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.englishListening.label': 'கேள்வி',
    'wizard.languageSkills.fields.englishListening.placeholder': 'நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.hasIELTS.label': 'உங்களிடம் IELTS முடிவுகள் உள்ளதா? *',
    'wizard.languageSkills.fields.hasIELTS.placeholder': 'IELTS நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.hasIELTS.options.yes': 'ஆம், எனக்கு IELTS முடிவுகள் உள்ளன',
    'wizard.languageSkills.fields.hasIELTS.options.no': 'இல்லை, நான் IELTS எழுதவில்லை',
    'wizard.languageSkills.fields.hasIELTS.options.planning': 'விரைவில் எழுத திட்டமிட்டுள்ளேன்',
    'wizard.languageSkills.fields.ieltsScore.label': 'IELTS மொத்த பேண்டு மதிப்பெண் *',
    'wizard.languageSkills.fields.ieltsScore.placeholder': 'IELTS மதிப்பெண்களைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.ieltsScore.clbHint': '💡 கனடிய குடியேற்றத்திற்கான CLB நிலை {{level}}க்கு சமமானது',
    'wizard.languageSkills.fields.hasTOEFL.label': 'உங்களிடம் TOEFL முடிவுகள் உள்ளதா? (விருப்பம்)',
    'wizard.languageSkills.fields.hasTOEFL.placeholder': 'TOEFL நிலையைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.hasTOEFL.options.yes': 'ஆம், எனக்கு TOEFL முடிவுகள் உள்ளன',
    'wizard.languageSkills.fields.hasTOEFL.options.no': 'இல்லை, நான் TOEFL எழுதவில்லை',
    'wizard.languageSkills.fields.toeflScore.label': 'TOEFL மொத்த மதிப்பெண்',
    'wizard.languageSkills.fields.toeflScore.placeholder': 'TOEFL மதிப்பெண்களைத் தேர்ந்தெடுக்கவும்',
    'wizard.languageSkills.fields.otherLanguages.label': 'மற்ற மொழிகள் (விருப்பம்)',
    'wizard.languageSkills.fields.otherLanguages.placeholder': 'நீங்கள் பேசும் பிற மொழிகள் மற்றும் திறன் நிலைகளை பட்டியலிடவும்',
    'wizard.languageSkills.fields.otherLanguages.helper': 'குடியேற்றத்திற்கு உதவும் பிரெஞ்சு, ஜெர்மன், ஸ்பானிஷ் போன்ற மொழிகளையும் சேர்க்கவும்',
    'wizard.languageSkills.notice.title': 'குடியேற்றத்திற்கு மொழித் தேவைகள்',
    'wizard.languageSkills.notice.body': 'பெரும்பாலான குடியேற்ற திட்டங்கள் குறைந்தபட்ச மொழித் திறனை கோருகிறது. IELTS போன்ற தரநிலைத் தேர்வு மதிப்பெண்கள் கட்டாயமாக இருக்கும் மற்றும் உங்கள் புள்ளி கணக்கீட்டில் நேரடியாக தாக்கத்தை ஏற்படுத்தும்.',
    'wizard.languageSkills.levels.beginner': 'ஆரம்ப நிலை (A1-A2)',
    'wizard.languageSkills.levels.intermediate': 'இடைநிலை (B1-B2)',
    'wizard.languageSkills.levels.advanced': 'மேம்பட்ட நிலை (C1)',
    'wizard.languageSkills.levels.native': 'தாய்மொழி/வழுக்கல் (C2)',
    'wizard.languageSkills.ielts.4_0_4_5': '4.0 - 4.5 (குறைந்த திறன்)',
    'wizard.languageSkills.ielts.5_0_5_5': '5.0 - 5.5 (மிதமான)',
    'wizard.languageSkills.ielts.6_0_6_5': '6.0 - 6.5 (திறமையான)',
    'wizard.languageSkills.ielts.7_0_7_5': '7.0 - 7.5 (நல்ல)',
    'wizard.languageSkills.ielts.8_0_8_5': '8.0 - 8.5 (மிகவும் நல்ல)',
    'wizard.languageSkills.ielts.9_0': '9.0 (நிபுணர்)',
    'wizard.languageSkills.toefl.0_30': '0-30 (குறைந்த)',
    'wizard.languageSkills.toefl.31_50': '31-50 (குறைந்த இடைநிலை)',
    'wizard.languageSkills.toefl.51_70': '51-70 (இடைநிலை)',
    'wizard.languageSkills.toefl.71_90': '71-90 (உயர் இடைநிலை)',
    'wizard.languageSkills.toefl.91_100': '91-100 (மேம்பட்ட)',
    'wizard.languageSkills.toefl.101_120': '101-120 (நிபுணர்)',
    'wizard.financialInfo.title': 'கல்வி பட்ஜெட்',
    'wizard.financialInfo.description': 'உங்களுக்கு கிடைக்கக்கூடிய கல்வி பட்ஜெட்டை அறிந்தால், உகந்த குடியேற்ற பாதைகள் மற்றும் நிதி விருப்பங்களை நாம் பரிந்துரைக்க முடியும்.',
    'wizard.financialInfo.errors.educationBudget.required': 'உங்கள் கல்வி பட்ஜெட்டைத் தேர்ந்தெடுக்கவும்',
    'wizard.financialInfo.fields.currency.label': 'விருப்ப நாணயம்',
    'wizard.financialInfo.fields.educationBudget.label': 'கிடைக்கும் கல்வி பட்ஜெட் *',
    'wizard.financialInfo.fields.educationBudget.placeholder': 'உங்கள் கல்வி பட்ஜெட்டைத் தேர்ந்தெடுக்கவும்',
    'wizard.financialInfo.fields.financialNotes.label': 'கூடுதல் நிதி குறிப்புகள் (விருப்பம்)',
    'wizard.financialInfo.fields.financialNotes.placeholder': 'உங்கள் நிதி நிலை, உதவித்தொகைகள் அல்லது நிதி ஆதாரங்கள் பற்றிய கூடுதல் தகவல்கள்',
    'wizard.financialInfo.fields.financialNotes.helper': 'உங்களிடம் உதவித்தொகைகள், குடும்ப ஆதர்வு அல்லது பிற நிதி ஏற்பாடுகள் இருந்தால் தெரிவிக்கவும்',
    'wizard.financialInfo.notice.title': 'உங்கள் பட்ஜெட் ஏன் முக்கியம்',
    'wizard.financialInfo.notice.body': 'உங்கள் கல்வி பட்ஜெட் எங்களுக்கு உகந்த குடியேற்ற பாதைகளை பரிந்துரைக்க உதவுகிறது. நாடு வாரியாக செலவுகள் மாறுபடும்: ஜெர்மனியில் தடை கணக்கு ({{symbol}}13,080/ஆண்டு) தேவை, கனடாவில் நிதி ஆதாரம் அவசியம், கல்விக் கட்டணங்களும் பெரிதும் மாறக்கூடும்.',
    'wizard.financialInfo.currencies.usd': 'USD - அமெரிக்க டாலர்',
    'wizard.financialInfo.currencies.eur': 'EUR - யூரோ',
    'wizard.financialInfo.currencies.gbp': 'GBP - பிரிட்டிஷ் பவுண்ட்',
    'wizard.financialInfo.currencies.cad': 'CAD - கனடிய டாலர்',
    'wizard.financialInfo.currencies.aud': 'AUD - ஆஸ்திரேலிய டாலர்',
    'wizard.financialInfo.currencies.lkr': 'LKR - இலங்கை ரூபாய்',
    'wizard.financialInfo.currencies.inr': 'INR - இந்திய ரூபாய்',
    'wizard.financialInfo.budgets.0_10000': '$10,000-க்கு குறைவானது',
    'wizard.financialInfo.budgets.10000_25000': '$10,000 - $25,000',
    'wizard.financialInfo.budgets.25000_50000': '$25,000 - $50,000',
    'wizard.financialInfo.budgets.50000_75000': '$50,000 - $75,000',
    'wizard.financialInfo.budgets.75000_plus': '$75,000-க்கு மேல்',
    'wizard.review.recommendations.title': 'பரிந்துரைக்கப்பட்ட குடியேற்ற விருப்பங்கள்',
    'wizard.review.proceedButton': 'இறுதி படிக்குச் செல்லவும்',
    'wizard.submit.title': 'உங்கள் சுயவிவரத்தை சமர்ப்பிக்கவும்',
    'wizard.submit.description': 'எங்கள் நிபுணர்களிடமிருந்து தனிப்பயன் குடியேற்ற பரிந்துரைகளைப் பெற உங்கள் முழு சுயவிவரத்தை சமர்ப்பிக்கவும்.',
    'wizard.submit.errors.agreeToTerms': 'தொடர Terms & Conditions-ஐ ஒப்புக்கொள்ளவும்.',
    'wizard.submit.actions.submitting': 'சமர்ப்பிக்கிறது...',
    'wizard.submit.actions.submitForReview': 'மதிப்பாய்வுக்கு சுயவிவரத்தை சமர்ப்பிக்கவும்',
    'wizard.dynamic.title': 'கூடுதல் கேள்விகள்',
    'wizard.dynamic.subtitle': 'சிறப்பான வழிகாட்டுதலை வழங்க இக்கேள்விகள் உதவுகின்றன.',
    'wizard.dynamic.radioGroupLabel': 'விருப்பத் தய்வுகள்',
    'wizard.dynamic.questions.ielts_status.question': 'உங்கள் IELTS நிலைமை என்ன?',
    'wizard.dynamic.questions.ielts_status.options.have_6_0': '6.0+ மதிப்பெண் உள்ளது',
    'wizard.dynamic.questions.ielts_status.options.taking_soon': 'விரைவில் எழுத திட்டமிட்டுள்ளேன்',
    'wizard.dynamic.questions.ielts_status.options.not_started': 'இன்னும் தொடங்கவில்லை',
    'wizard.dynamic.questions.ielts_status.options.need_help': 'உதவி தேவை',
    'wizard.dynamic.questions.al_results.question': 'உங்கள் A/L முடிவுகள் என்ன?',
    'wizard.dynamic.questions.al_results.options.3_passes': '3 தேர்ச்சி',
    'wizard.dynamic.questions.al_results.options.2_passes': '2 தேர்ச்சி',
    'wizard.dynamic.questions.al_results.options.1_pass': '1 தேர்ச்சி',
    'wizard.dynamic.questions.al_results.options.still_waiting': 'முடிவுக்காக காத்திருக்கிறேன்',
    'wizard.dynamic.questions.program_interest.question': 'எந்த பாடத்திட்டத்தில் உங்களுக்கு விருப்பம்?',
    'wizard.dynamic.questions.program_interest.options.1_year_pg_certificate': '1 ஆண்டுப் பின் பட்டப் சான்றிதழ்',
    'wizard.dynamic.questions.program_interest.options.2_year_pg_diploma': '2 ஆண்டுப் பின் பட்ட டிப்ளமா',
    'wizard.dynamic.questions.program_interest.options.certificate': 'சான்றிதழ்',
    'wizard.dynamic.questions.program_interest.options.diploma': 'டிப்ளமா',
    'wizard.dynamic.questions.program_interest.options.bachelor_master': 'இளங்கலை/முதுகலை',
    'wizard.dynamic.questions.program_interest.options.need_guidance': 'வழிகாட்டுதல் தேவை',
    'wizard.dynamic.questions.program_interest.options.bachelor_s_degree': 'இளங்கலை பட்டம்',
    'wizard.dynamic.questions.program_interest.options.master_s_degree': 'முதுகலை பட்டம்',
    'wizard.dynamic.questions.program_interest.options.graduate_diploma': 'பட்டப்படிப்பு டிப்ளமா',
    'wizard.dynamic.questions.program_interest.options.vocational_education': 'தொழிற் பயிற்சி கல்வி',
    'wizard.dynamic.questions.program_interest.options.phd': 'பிஎச்.டி',
    'wizard.dynamic.questions.program_interest.options.foundation_course': 'அடிப்படை பாடநெறி',
    'wizard.dynamic.questions.program_interest.options.associate_degree': 'துணை பட்டம்',
    'wizard.financial.title': '{{country}} பற்றிய நிதி தகவல்',
    'wizard.financial.subtitle': 'அத்தியாவசிய செலவுகள் மற்றும் நிதி தேவைகள்',
    'wizard.financial.tipTitle': 'குறிப்பு:',
    'wizard.financial.tipBody': 'இவை மதிப்பீடுகள் மட்டுமே; உங்கள் நிலைமைக்கு ஏற்ப மாறலாம்.',
    'wizard.financial.titles.blockedAccount': 'தடையணை கணக்கு தேவைகள்',
    'wizard.financial.titles.sponsorSavings': 'ஸ்பான்சர் நன்மைகள்',
    'wizard.financial.titles.tuition': 'கல்விக் கட்டணம்',
    'wizard.financial.titles.loanOption': 'கட்டணம் செலுத்தும் விருப்பங்கள்',
    'wizard.financial.titles.costs': 'மதிப்பீட்டு செலவுகள்',
    'wizard.financial.titles.workPermit': 'வேலை உரிமைகள்',
    'wizard.financial.titles.workRights': 'வேலை உரிமைகள்',
    'wizard.financial.titles.postStudy': 'படிப்புக்கு பிந்தைய வாய்ப்புகள்',
    'wizard.financial.titles.guidance': 'எங்கள் வழிகாட்டுதல்',
    'wizard.financial.titles.comparison': 'ஒப்பீடு சேவை',
    'wizard.financial.titles.support': 'ஆதரவு',
    'wizard.financial.titles.budgetRange': 'பட்ஜெட் திட்டமிடல்',
    'wizard.submit.finalStep': 'இறுதி படி',
    'wizard.insights.progress': 'முன்னேற்றம்',
    'wizard.insights.complete': 'முடிந்தது',
    'wizard.insights.mobileToggleTitle': 'படிப்படியான வழிகாட்டுதல்',
    'wizard.insights.expand': 'திறக்கவும்',
    'wizard.insights.collapse': 'மூடவும்',
    'wizard.insights.fastTipTitle': 'விரைவு குறிப்பு',
    'wizard.insights.fastTipBody': 'விசார்டை ஒரே அமர்வில் முடித்தால் "Immigration Readiness Pack" உடனே கிடைக்கும். விரைவில் சமர்ப்பிப்பவர்கள் 48 மணிநேரத்துக்குள் ஆலோசனை நேரம் பெறுகிறார்கள்.',
    'wizard.insights.snapshotTitle': 'இப்போதுவரை உங்கள் தகவல்',
    'wizard.insights.snapshot.notSelected': 'தேர்ந்தெடுக்கப்படவில்லை',
    'wizard.insights.snapshot.destination': 'தேர்ந்தெடுத்த நாடு',
    'wizard.insights.snapshot.applicant': 'விண்ணப்பதாரர்',
    'wizard.insights.snapshot.education': 'உயர்ந்த கல்வி',
    'wizard.insights.snapshot.experience': 'அனுபவ வருசங்கள்',
    'wizard.insights.snapshot.years': 'years',
    'wizard.insights.snapshot.language': 'மொழி நிலை',
    'wizard.insights.nextTitle': 'அடுத்ததாக',
    'wizard.insights.nextDescription': 'அடுத்த படியில் {{title}} குறித்து கவனம் செலுத்துவீர்கள்',
    'consult.chat.initialPrompt': 'வணக்கம்! நான் உங்கள் AI குடியேற்ற ஆலோசகர். தொடங்குவதற்கு முன், இந்த உரையாடலுக்கான மொழியை தேர்ந்தெடுக்க முடியுமா? (ஆங்கிலம் / தமிழ் / சிங்களம்)',
    'consult.chat.resetPrompt': 'மீண்டும் வணக்கம்! இன்று எந்த மொழியைப் பயன்படுத்த விரும்புகிறீர்கள்? (ஆங்கிலம் / தமிழ் / சிங்களம்)',
    // Choice Page
    'choice.title': 'இன்று நாங்கள் எவ்வாறு உங்களுக்கு உதவ முடியும்?',
    'choice.subtitle': 'உங்கள் தற்போதைய தேவைகளுக்கு ஏற்ற பாதையைத் தேர்வு செய்யுங்கள். அனைத்து பாதைகளும் உங்கள் வெளிநாட்டு கல்வி கனவுக்கு வழிவகுக்கும்!',
    'choice.option1.icon': '🎯',
    'choice.option1.title': 'எனக்கு சிறந்த வழியைக் கண்டறியவும்',
    'choice.option1.description': 'எந்த நாடு அல்லது திட்டம் உங்களுக்கு மிகவும் பொருத்தமானது என்று தெரியவில்லையா? உங்கள் சுயவிவரம், பட்ஜெட் மற்றும் இலக்குகளின் அடிப்படையில் தனிப்பயனாக்கப்பட்ட பரிந்துரைகளைப் பெற எங்கள் ஸ்மார்ட் மதிப்பீட்டை எடுக்கவும்.',
    'choice.option1.feature1': 'AI-இயக்கப்பட்ட நாடு பொருத்தம்',
    'choice.option1.feature2': 'பட்ஜெட் பகுப்பாய்வு & திட்டமிடல்',
    'choice.option1.feature3': 'தொழில் பாதை பரிந்துரைகள்',
    'choice.option1.feature4': 'உடனடி தகுதி சரிபார்ப்பு',
    'choice.option1.cta': 'இலவச மதிப்பீட்டைத் தொடங்கவும்',
    'choice.option1.badge': 'பரிந்துரைக்கப்பட்டது',
    'choice.option2.icon': '💬',
    'choice.option2.title': 'எனக்கு என்ன வேண்டும் என்று தெரியும் - நிபுணருடன் பேசுங்கள்',
    'choice.option2.description': 'உங்கள் இலக்கு மற்றும் திட்டத்தை ஏற்கனவே தீர்மானித்துவிட்டீர்களா? தனிப்பயனாக்கப்பட்ட வழிகாட்டுதலுக்காக எங்கள் குடியேற்ற வல்லுநர்களுடன் நேரடியாக இணைந்து உங்கள் விண்ணப்ப செயல்முறையை விரைவுபடுத்துங்கள்.',
    'choice.option2.feature1': 'நேரடி நிபுணர் ஆலோசனை',
    'choice.option2.feature2': 'விண்ணப்ப விரைவுபடுத்தல்',
    'choice.option2.feature3': 'ஆவணம் தயாரிப்பு உதவி',
    'choice.option2.feature4': 'விசா நேர்காணல் பயிற்சி',
    'choice.option2.cta': 'இப்போது நிபுணரைத் தொடர்பு கொள்ளுங்கள்',
    'choice.option3.icon': '📚',
    'choice.option3.title': 'எனக்கு தகவல் மட்டும் தேவை',
    'choice.option3.description': 'உங்கள் விருப்பங்களை ஆராய்ந்து மேலும் அறிய விரும்புகிறீர்களா? அனைத்து 5 நாடுகளுக்கான திட்டங்கள், செலவுகள், தேவைகள் மற்றும் செயல்முறைகள் பற்றிய உடனடி பதில்களைப் பெற எங்கள் AI உதவியாளருடன் அரட்டை அடிக்கவும்.',
    'choice.option3.feature1': '24/7 AI உதவியாளர் கிடைக்கும்',
    'choice.option3.feature2': 'அடிக்கடி கேட்கப்படும் கேள்விகளுக்கு உடனடி பதில்கள்',
    'choice.option3.feature3': 'திட்ட ஒப்பீடுகள்',
    'choice.option3.feature4': 'செலவு பகுப்பாய்வு',
    'choice.option3.cta': 'AI உதவியாளருடன் அரட்டை அடிக்கவும்',
    'choice.trust.title': '1000+ மாணவர்கள் ரவானா மைக்ரேஷனை நம்புவது ஏன்?',
    'choice.trust.stat1.value': '99%',
    'choice.trust.stat1.label': 'வெற்றி விகிதம்',
    'choice.trust.stat2.value': '5',
    'choice.trust.stat2.label': 'நாடுகள்',
    'choice.trust.stat3.value': '7+',
    'choice.trust.stat3.label': 'வருட அனுபவம்',
    'choice.trust.stat4.value': '1000+',
    'choice.trust.stat4.label': 'உதவிய மாணவர்கள்',
    'choice.trust.stat5.value': '100%',
    'choice.trust.stat5.label': 'வெளிப்படையானது',
    'choice.help.text': 'இன்னும் உங்களுக்கு எந்த விருப்பம் சரி என்று தெரியவில்லையா?',
    'choice.help.link1': 'எங்களைப் பற்றி மேலும் அறிக',
    'choice.help.link2': 'எங்கள் தொகுப்புகளைக் காண்க',
    'choice.help.link3': 'சேவைகளை ஆராயுங்கள்',
    // Home Page
    'home.ravana.global.track.title': 'ரவாண குளோபல் ட்ராக்™ — ஒரு விண்ணப்பம். ஐந்து இடங்கள்.',
    'home.ravana.global.track.subtitle': 'ஒரு கூட்டாளி. ஐந்து நாடுகள். எண்ணற்ற சாத்தியங்கள்.',
    'home.ravana.global.track.description': 'ஜெர்மனி, கனடா, ஆஸ்திரேலியா, ஐக்கிய இராச்சியம் மற்றும் நியூசிலாந்து முழுதும் விசா மற்றும் குடியேற்ற சேவைகள்.',
    'home.hero.tagline': 'வெளிநாடுகளில் படிப்பு, வேலை மற்றும் குடியேற்றம் — ஒரு கூட்டாளி. ஐந்து நாடுகள்.',
    'home.why.choose.title': 'ரவாண மைக்ரேஷனை ஏன் தேர்ந்தெடுக்க வேண்டும்?',
    'home.cta.journey': 'உங்கள் பயணத்தைத் தொடங்க தயாரா?',
    'home.cta.chat.expert': 'நிபுணருடன் அரட்டை அடிக்கவும்',
    'home.cta.start.assessment': 'இலவச மதிப்பீட்டைத் தொடங்கவும்',
    // Services Page
    'services.hero.title': 'ரவாண குளோபல் ட்ராக்™ சேவைகள்',
    'services.hero.subtitle': 'ஒரு கூட்டாளி. ஐந்து நாடுகள். எண்ணற்ற சாத்தியங்கள்.',
    'services.hero.description': 'ஜெர்மனி, கனடா, ஆஸ்திரேலியா, ஐக்கிய இராச்சியம் மற்றும் நியூசிலாந்து முழுதும் விசா மற்றும் குடியேற்ற சேவைகள்.',
    'services.why.choose.title': 'எங்கள் சேவைகளை ஏன் தேர்ந்தெடுக்க வேண்டும்?',
    'services.why.choose.subtitle': 'உலகெங்கிலும் உள்ள மாணவர்களால் நம்பப்படுகிறது',
    'services.additional.title': 'கூடுதல் ஆதரவு சேவைகள்',
    'services.additional.subtitle': 'எங்கள் அனைத்து தொகுப்புகளிலும் அடங்கும் விரிவான ஆதரவு சேவைகள்',
    'services.cta.journey': 'உங்கள் பயணத்தைத் தொடங்க தயாரா?',
    'services.cta.contact': 'எங்களைத் தொடர்பு கொள்ளுங்கள்',
    // About Page
    'about.cta.journey': 'உங்கள் பயணத்தைத் தொடங்க தயாரா?',
    'about.cta.consultation': 'இலவச ஆலோசனை முன்பதிவு செய்யுங்கள்',
    // Global Branding
    'global.tagline': 'ஒரு விண்ணப்பம். ஐந்து இடங்கள். ஒரு உலகளாவிய கூட்டாளி.',
    'global.track.name': 'ரவாண குளோபல் ட்ராக்™',
    'global.countries': 'ஜெர்மனி • கனடா • ஆஸ்திரேலியா • ஐக்கிய இராச்சியம் • நியூசிலாந்து',
    // Country Names
    'country.germany': 'ஜெர்மனி',
    'country.canada': 'கனடா',
    'country.australia': 'ஆஸ்திரேலியா',
    'country.uk': 'ஐக்கிய இராச்சியம்',
    'country.newzealand': 'நியூசிலாந்து',
    // Common Actions
    'common.get.started': 'தொடங்குங்கள்',
    'common.learn.more': 'மேலும் அறிக',
    'common.contact.us': 'எங்களைத் தொடர்பு கொள்ளுங்கள்',
    'common.book.consultation': 'ஆலோசனை முன்பதிவு செய்யுங்கள்',
    'common.start.assessment': 'மதிப்பீடு தொடங்குங்கள்',
    'common.chat.expert': 'நிபுணருடன் அரட்டை'
  },
  si: {
    'wizard.common.stepIndicator': '{{total}} තුළ {{current}} වන පියවර',
    'wizard.common.previous': 'පසු යන්න',
    'wizard.language.title': 'ඔබට වඩාත් පහසු භාෂාව තෝරන්න',
    'wizard.language.subtitle': 'ඔබට අතළුවන භාෂාව තෝරන්න. අවශ්‍ය වේලාවක ම භාෂාව වෙනස් කර ගත හැක; සියලුම ලිහිල්පත් සහ සටහන් එම භාෂාවේ ලැබේ.',
    'wizard.language.option.en.label': 'ඉංග්‍රීසි',
    'wizard.language.option.en.native': 'English',
    'wizard.language.option.en.description': 'වීසා ලේඛන සඳහා සුදුසු ජාත්‍යන්තර ඉංග්‍රීසි මඟපෙන්වීම.',
    'wizard.language.option.en.badge': 'ලේඛන සඳහා නිර්දේශිත',
    'wizard.language.option.ta.label': 'දෙමළ',
    'wizard.language.option.ta.native': 'தமிழ்',
    'wizard.language.option.ta.description': 'සියලු උපදෙස් දෙමළ භාෂාවේ ලබා ගන්න. සහකරු සමඟ සබැඳිය පහසු වේ.',
    'wizard.language.option.ta.badge': 'தமீழ் ஆதரவு',
    'wizard.language.option.si.label': 'සිංහල',
    'wizard.language.option.si.native': 'සිංහල',
    'wizard.language.option.si.description': 'සිංහලෙන් සම්පූර්ණ මඟපෙන්වීම. දුරකථන ඇමතුම් සඳහා පහසුයි.',
    'wizard.language.option.si.badge': 'සිංහල සහය සපයා ඇත',
    'wizard.language.tipTitle': 'මෙය ඇහීමේ හේතුව',
    'wizard.language.tip1': 'ඉදිරි සියලු கேள்வි, நினைவூட்டல்கள் සහ වීසා ලිහිල්පත් මෙම භාෂාවේ ලැබේ.',
    'wizard.language.tip2': 'ඔබේ පිළිතුරු ඔබ තෝරාගත් භාෂාවෙන්ම උපදේශකයින් සකස් කරයි.',
    'wizard.language.tip3': 'පසුව භාෂාව වෙනස් කළහොත් ලේඛන ආකෘති සහ දැනුම්දීම් වහාම යාවත්කාලීන වේ.',
    'wizard.language.next': 'අගුලු හරින්න',
    'wizard.steps.language': 'භාෂාව',
    'wizard.steps.country': 'රට',
    'wizard.steps.personal': 'දීලත් තොරතුරු',
    'wizard.steps.education': 'අධ්‍යයනය',
    'wizard.steps.experience': 'ජොබ් අත්දැකීම්',
    'wizard.steps.languageSkills': 'භාෂා දක්ෂතා',
    'wizard.steps.cvUpload': 'CV උඩුගත කිරීම',
    'wizard.steps.financial': 'මූල්‍ය',
    'wizard.steps.review': 'සංශෝධනය',
    'wizard.steps.submit': 'ඉදිරිපත් කරන්න',
    'wizard.header.title': 'ජනාධිපතිත්ව සුදුසුකම් විසාඩය්',
    'wizard.header.subtitle': 'අපගේ AI මඟපෙන්වීමෙන් ඔබට සුදුසු ඉමික්‍රේෂන් මාර්ගය සොයාගන්න. ඔබගේ பின்னணி පිළිබඳ කිහිප සාමාන්‍ය ප්රශ්න වලට පිළිතුරු දී පුද්ගලික නිර්දේශ ලබාගන්න.',
    'wizard.header.badgeTime': 'මිනිත්තු 6 ක් පමණින් අවසන්',
    'wizard.header.badgeReview': 'ඔබේ පිළිතුරු උපදේශකයින් පූර්වාවලෝකනය කරයි',
    'wizard.help.text': 'උදව් අවශ්‍යද? අපගේ විශේෂඥයන්ව සම්බන්ධ වන්න:',
    'wizard.help.email': 'info@ravanaindustries.com',
    'wizard.country.quickFacts.time.label': ' අවසන් වේලාව',
    'wizard.country.quickFacts.time.value': '≈ 6 මිනිත්තු',
    'wizard.country.quickFacts.time.description': 'එක් වාරයක් තුළ අවසන් කළහොත් උපදේශකයින් සූදානම් වේ.',
    'wizard.country.quickFacts.docs.label': 'ලේඛන කාලය ඉතිරිකිරීම',
    'wizard.country.quickFacts.docs.value': 'විනාඩි 30+',
    'wizard.country.quickFacts.docs.description': 'ඔබ ලබාදුන් පිළිතුරු මත යාවත්කාලීන ලේඛන සකස් කරමු.',
    'wizard.country.quickFacts.pathways.label': 'විකල්ප මාර්ග',
    'wizard.country.quickFacts.pathways.value': 'විශේෂ 3',
    'wizard.country.quickFacts.pathways.description': 'ඔබේ දත්තයට ගැළපෙන පාඨමාලා/රැකියා මාර්ග පෙන්නුම් කරයි.',
    'wizard.country.guidance.germany.title': 'ජර්මනියෙන් බලාපොරොත්තු විය හැක්කේ',
    'wizard.country.guidance.germany.bullet1': '€0 පාඨමාලා ගාස්තු සහිත රාජ්‍ය විශ්වවිද්‍යාලවල ඉංග්‍රීසි භාෂාවෙන් පවත්වන බච්ලර් සහ මැස්ටර් වැඩසටහන්.',
    'wizard.country.guidance.germany.bullet2': 'Chancenkarte සහ දක්ෂ සේවක මාර්ග: ලකුණු පදනම් ඇගයීම් සහ ඉක්මන් රැකියා වෙළඳපොළ සහය.',
    'wizard.country.guidance.germany.bullet3': 'මෙම පියවරෙන් පසු වහාම අවහිර ගිණුම් මගපෙන්වීම සහ බැංකු හවුල්කරුවන් බෙදාහරියි.',
    'wizard.country.guidance.canada.title': 'කැනඩාවෙන් බලාපොරොත්තු විය හැක්කේ',
    'wizard.country.guidance.canada.bullet1': 'PG ඩිප්ලෝමා අරමුදල් විකල්ප: 25% පෙර ගෙවීම සහ 75% පැමිණීමට පසු මූල්‍ය පහසුකම්.',
    'wizard.country.guidance.canada.bullet2': 'PGWP කාලසටහන් සහ පළාත් අනුව ඇතුළත් වීමේ කාලසටහන් ඔබගේ පුද්ගලික පැකේජයට ඇතුළත්යි.',
    'wizard.country.guidance.canada.bullet3': 'අධ්‍යයනය සමඟ රැකියා සිතියමක් සහ පළාත් අනුව සාමාන්‍ය ආදායම්.',
    'wizard.country.guidance.uk.title': 'එක්සත් රාජධානියෙන් බලාපොරොත්තු විය හැක්කේ',
    'wizard.country.guidance.uk.bullet1': 'එක වසරක් දිගු මැස්ටර් පාඨමාලා සහ Graduate Route දිගු කිරීමේ විස්තර.',
    'wizard.country.guidance.uk.bullet2': 'ශිෂ්‍යත්ව කෙටි ලැයිස්තු සහ CAS සැකසුම් කාලසටහන් ස්වයංක්‍රීයව සකස් වේ.',
    'wizard.country.guidance.uk.bullet3': 'වීසා සාර්ථකත්ව පරික්ෂා ලැයිස්තුව: නඩත්තු අරමුදල් සහ නවාතැන් සාධක ඇතුළත්.',
    'wizard.country.guidance.notSure.title': 'තීරණයක් ගැනීමට උදව් අවශ්‍යද?',
    'wizard.country.guidance.notSure.bullet1': 'ඔබේ ඉලක්ක අපට කියන්න; ජර්මනි, කැනඩා සහ එක්සත් රාජධානියේ සාර්ථකත්ව අනුපාත අපි සංසන්දනය කරමු.',
    'wizard.country.guidance.notSure.bullet2': 'වෘත්තීය සමගහිත කෙටි ලැයිස්තුවක් ලබාගන්න: වීසා කාලසටහන් සහ අවශ්‍ය ආයෝජනය සමඟ.',
    'wizard.country.guidance.notSure.bullet3': 'භාෂාව, මුදල් සහ ලේඛන අපේක්ෂා ආවරණය කරන සූදානම් පැකේජයක් ලබාගන්න.',
    'wizard.country.guidance.fallback.title': 'ඊළඟට මොනවා සිදුවේද',
    'wizard.country.guidance.fallback.bullet1': 'වීසා අවශ්‍යතා, පාඨමාලා ගාස්තු හෝ වැටුප් බලාපොරොත්තු සහ උපදේශකයා සඳහා මීළඟ පියවර අපි සාරාංශ කරමු.',
    'wizard.country.guidance.fallback.bullet2': 'ඉදිරිපත් කිරීමෙන් පසු වහාම බාගත කළ හැකි සූදානම් මාර්ගෝපදේශ ඔබට ලැබේ.',
    'wizard.country.guidance.fallback.bullet3': 'අපේ විශේෂඥයින් ඇමතුමට පෙර ඔබගේ පැතිකඩ සමාලෝචනය කරන නිසා ඔබට සැලසුම් කිරීමට ක්ෂණිකව හැක.',
    'wizard.country.guidance.default.title': 'ඔබේ තේරීම අපේක්ෂා කරනවා',
    'wizard.country.guidance.default.bullet1': 'ඔබ තෝරාගත් රටේ නීති අනුව ඉදිරි ප්රශ්න සකස් කරයි.',
    'wizard.country.guidance.default.bullet2': 'වීසා අවශ්යතා, වියදම්, ක්‍රමලේඛන පූර්වයෙන්ම යාවත්කාලීන වේ.',
    'wizard.country.guidance.default.bullet3': 'ඉදිරිපත් කිරීමට පෙර ඕනෑම වෙලාවක රට මාරු කළ හැක; පිළිතුරු ස්වයංක්‍රීයෙන් යාවත්කාලීන වේ.',
    'wizard.personal.title': 'පෞද්ගලික තොරතුරු',
    'wizard.personal.description': 'ඔබ ගැන අපට කියන්න, එවිට ඔබට උපයෝගී ඉමයික්‍රේෂන් උපදෙස් ලබා දිය හැක.',
    'wizard.personal.tipTitle': 'මේ කාලයේ වැදගත්කම',
    'wizard.personal.tip1': 'ඔබ සඳහන් කරන ආකාරයටම ලේඛන සකස් කරන්නට අපට හැක.',
    'wizard.personal.tip2': 'ඔබේ සම්බන්ධතා පෞද්ගලික වශයෙන් ලබා दिलால் හිඟ පැකේජය සියලුම උපදෙස් සමඟ ලබා දෙන්නට හැක.',
    'wizard.personal.tip3': 'රට/නගරය අනුව තානාපති කාර්යාල දිනයන් තීරණය වන අතර ඔබට වේගවත් මධ්‍යස්ථානයක් ඇවරණය කර දීමේ හැකියාව ඇත.',
    'wizard.personal.phoneHelper': 'දුරකථන කේතය ඇතුළත් කරන්න; WhatsApp හෝ ඇමතුම් සඳහා පහසුයි.',
    'wizard.personal.fields.firstName.label': 'පළමු නම *',
    'wizard.personal.fields.firstName.placeholder': 'ඔබගේ පළමු නම ඇතුළත් කරන්න',
    'wizard.personal.fields.lastName.label': 'අවසන් නම *',
    'wizard.personal.fields.lastName.placeholder': 'ඔබගේ අවසාන නම ඇතුළත් කරන්න',
    'wizard.personal.fields.email.label': 'ඊමේල් ලිපිනය *',
    'wizard.personal.fields.email.placeholder': 'your.email@example.com',
    'wizard.personal.fields.phone.label': 'දුරකථන අංකය *',
    'wizard.personal.fields.phone.placeholder': '+94 77 123 4567',
    'wizard.personal.fields.dateOfBirth.label': 'උපන් දිනය *',
    'wizard.personal.fields.dateOfBirth.helper': 'වයස පදනම් වීසා ලකුණු ගණනය කිරීමටත් සුදුසුකම් සීමාට පෙර මතක් කිරීම් සැකසීමටත් මෙය භාවිත කරනවා.',
    'wizard.personal.fields.nationality.label': 'දේශීයභාවය *',
    'wizard.personal.fields.nationality.placeholder': 'ඔබගේ ජාතිකත්වය තෝරන්න',
    'wizard.personal.fields.currentCountry.label': 'දැනට පදිංචි රට *',
    'wizard.personal.fields.currentCountry.placeholder': 'ඔබ දැනට පදිංචි රට තෝරන්න',
    'wizard.personal.errors.firstName.required': 'පළමු නම අවශ්‍යයි',
    'wizard.personal.errors.firstName.min': 'පළමු නමට අවමෙන් හෝ අක්ෂර {{min}}ක් තිබිය යුතුය',
    'wizard.personal.errors.lastName.required': 'අවසන් නම අවශ්‍යයි',
    'wizard.personal.errors.lastName.min': 'අවසන් නමට අවමෙන් හෝ අක්ෂර {{min}}ක් තිබිය යුතුය',
    'wizard.personal.errors.email.required': 'ඊමේල් ලිපිනය අවශ්‍යයි',
    'wizard.personal.errors.email.invalid': 'කරුණාකර වලංගු ඊමේල් ලිපිනයක් ඇතුළත් කරන්න',
    'wizard.personal.errors.phone.required': 'දුරකථන අංකය අවශ්‍යයි',
    'wizard.personal.errors.phone.invalid': 'කරුණාකර වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න',
    'wizard.personal.errors.dateOfBirth.required': 'උපන් දිනය අවශ්‍යයි',
    'wizard.personal.errors.dateOfBirth.range': 'වයස අවුරුදු {{min}} සහ {{max}} අතර විය යුතුයි',
    'wizard.personal.errors.nationality.required': 'දේශීයභාවය තෝරන්න',
    'wizard.personal.errors.currentCountry.required': 'දැනට පදිංචි රට තෝරන්න',
    'wizard.education.title': 'අධ්‍යාපනික පසුබිම',
    'wizard.education.description': 'විවිධ ඉමිග්‍රේෂන් වැඩසටහන් සඳහා ඔබගේ සුදුසුකම් ඇගයීමට, ඔබගේ අධ්‍යාපන තොරතුරු අපට ලබා දෙන්න.',
    'wizard.education.errors.highestEducation.required': 'කරුණාකර ඔබගේ උසස් අධ්‍යාපන මට්ටම තෝරන්න',
    'wizard.education.errors.fieldOfStudy.required': 'කරුණාකර ඔබගේ ඉගෙනුම් ක්ෂේත්‍රය තෝරන්න',
    'wizard.education.errors.university.required': 'විශ්වවිද්‍යාලය/ආයතනයේ නම අවශ්‍යයි',
    'wizard.education.errors.graduationYear.required': 'ඉගෙනුම් අවසන් කළ වර්ෂය අවශ්‍යයි',
    'wizard.education.errors.graduationYear.invalid': 'කරුණාකර වලංගු වර්ෂයක් ඇතුළත් කරන්න',
    'wizard.education.fields.highestEducation.label': 'උසස්ම අධ්‍යාපන මට්ටම *',
    'wizard.education.fields.highestEducation.placeholder': 'ඔබගේ උසස් අධ්‍යාපන මට්ටම තෝරන්න',
    'wizard.education.fields.fieldOfStudy.label': 'ඉගෙනුම් ක්ෂේත්‍රය *',
    'wizard.education.fields.fieldOfStudy.placeholder': 'ඔබගේ ඉගෙනුම් ක්ෂේත්‍රය තෝරන්න',
    'wizard.education.fields.university.label': 'විශ්වවිද්‍යාලය / ආයතනය / පාසල *',
    'wizard.education.fields.university.placeholder': 'ඔබගේ විශ්වවිද්‍යාලයේ නම ඇතුළත් කරන්න',
    'wizard.education.fields.graduationYear.label': 'ඉගෙනුම් අවසන් කළ වර්ෂය / A Level විභාග වර්ෂය *',
    'wizard.education.fields.graduationYear.placeholder': 'උදා., 2020',
    'wizard.education.fields.grades.label': 'ස්ථාන / GPA / ප්‍රතිඵල (විකල්පය)',
    'wizard.education.fields.grades.placeholder': 'උදා., GPA 3.8, First Class Honors, A ශ්‍රේණි',
    'wizard.education.fields.grades.helper': 'මෙය දක්ෂතාවය පදනම් වැඩසටහන් සඳහා ඔබගේ සුදුසුකම් ඇගයීමට අපට උපකාරී වේ',
    'wizard.education.fields.additionalCertificates.label': 'අමතර සහතික (විකල්පය)',
    'wizard.education.fields.additionalCertificates.placeholder': 'වෘත්තීය සහතික හෝ අමතර සුදුසුකම් ලැයිස්තුගත කරන්න',
    'wizard.education.fields.additionalCertificates.helper': 'වෘත්තීය බලපත්‍ර, සහතික හෝ විශේෂ පුහුණුව ඇතුළත් කරන්න',
    'wizard.education.notice.title': 'මෙම තොරතුරේ වැදගත්කම',
    'wizard.education.notice.body': 'ඔබගේ අධ්‍යාපනික පසුබිම ඔබට ගැළපෙන ඉමිග්‍රේෂන් වැඩසටහන් හඳුනා ගැනීමට අපට උපකාරී වේ. රටවල් අනුව වීසා කාණ්ඩ සඳහා විශේෂ අධ්‍යාපන අවශ්‍යතා තිබේ.',
    'wizard.education.levels.highSchool': 'මධ්‍යම පාසල් / O-ලෙවල්',
    'wizard.education.levels.aLevels': 'A-ලෙවල්',
    'wizard.education.levels.diploma': 'ඩිප්ලෝමා',
    'wizard.education.levels.bachelors': 'බැචලර් උපාධිය',
    'wizard.education.levels.masters': 'මාස්ටර්ස් උපාධිය',
    'wizard.education.levels.phd': 'පීඑච්ඩී / ඩොක්ටරේට්',
    'wizard.education.levels.professionalCertification': 'වෘත්තීය සහතික',
    'wizard.education.levels.other': 'වෙනත්',
    'wizard.education.fields.engineering': 'ඉංජිනේරු විද්යාව',
    'wizard.education.fields.medicineHealthcare': 'වෛද්‍ය / සෞඛ්‍ය',
    'wizard.education.fields.business': 'ව්‍යාපාර කළමනාකරණය',
    'wizard.education.fields.it': 'සංගණන විද්යාව / IT',
    'wizard.education.fields.naturalSciences': 'ස්වභාවික විද්‍යාව',
    'wizard.education.fields.socialSciences': 'සමාජ විද්‍යාව',
    'wizard.education.fields.artsHumanities': 'අලංකාර කලාව සහ මානව විද්‍යාව',
    'wizard.education.fields.law': 'නීතිය',
    'wizard.education.fields.education': 'අධ්‍යාපනය',
    'wizard.education.fields.agriculture': 'කෘෂිකර්ම',
    'wizard.education.fields.other': 'වෙනත්',
    'wizard.experience.title': 'රැකියා අත්දැකීම්',
    'wizard.experience.description': 'ඔබගේ වෘත්තීය අත්දැකීම් ඔබගේ ඉමිග්‍රේෂන් සුදුසුකම සහ ලකුණු ගණනයට දැඩි බලපෑමක් කරයි.',
    'wizard.experience.errors.totalExperience.required': 'ඔබගේ සම්පූර්ණ රැකියා අත්දැකීම් තෝරන්න',
    'wizard.experience.errors.hasInternationalExperience.required': 'ඔබගේ අන්තර්ජාතික අත්දැකීම් තත්ත්වය තෝරන්න',
    'wizard.experience.errors.jobTitle.required': 'රැකියා තනතුර අවශ්‍යයි',
    'wizard.experience.errors.company.required': 'කම්පැනි නම අවශ්‍යයි',
    'wizard.experience.errors.industry.required': 'ඔබගේ කාර්මික ක්ෂේත්‍රය තෝරන්න',
    'wizard.experience.errors.currentJobStatus.required': 'දැනට වන රැකියා තත්ත්වය තෝරන්න',
    'wizard.experience.fields.totalExperience.label': 'සම්පූර්ණ රැකියා අත්දැකීම් *',
    'wizard.experience.fields.totalExperience.placeholder': 'ඔබගේ අත්දැකීම් තෝරන්න',
    'wizard.experience.fields.hasInternationalExperience.label': 'අන්තර්ජාතික රැකියා අත්දැකීම් *',
    'wizard.experience.fields.hasInternationalExperience.placeholder': 'අන්තර්ජාතික අත්දැකීම් තෝරන්න',
    'wizard.experience.fields.hasInternationalExperience.options.yes': 'ඔව්, මට අන්තර්ජාතික රැකියා අත්දැකීම් ඇත',
    'wizard.experience.fields.hasInternationalExperience.options.no': 'නැහැ, මට දේශීය අත්දැකීම් පමණක් තිබේ',
    'wizard.experience.fields.jobTitle.label': 'දැනට/නවතම රැකියා තනතුර *',
    'wizard.experience.fields.jobTitle.placeholder': 'උදා., මෘදුකාංග ඉංජිනේරු, වෙළඳ ප්‍රවර්ධන කළමනාකරු',
    'wizard.experience.fields.company.label': 'දැනට/නවතම කම්පැනිය *',
    'wizard.experience.fields.company.placeholder': 'ඔබගේ කම්පැනි නම ඇතුළත් කරන්න',
    'wizard.experience.fields.industry.label': 'කාර්මික ක්ෂේත්‍රය *',
    'wizard.experience.fields.industry.placeholder': 'ඔබගේ කාර්මික ක්ෂේත්‍රය තෝරන්න',
    'wizard.experience.fields.currentJobStatus.label': 'දැනට වන රැකියා තත්ත්වය *',
    'wizard.experience.fields.currentJobStatus.placeholder': 'ඔබගේ තත්ත්වය තෝරන්න',
    'wizard.experience.fields.skills.label': 'ප්‍රධාන දක්ෂතා සහ විශේෂතා (විකල්පය)',
    'wizard.experience.fields.skills.placeholder': 'ඔබගේ ප්‍රධාන වෘත්තීය දක්ෂතා, තාක්ෂණික විශේෂතා සහ විශේෂීකරණ ලැයිස්තුගත කරන්න',
    'wizard.experience.fields.skills.helper': 'තාක්ෂණික දක්ෂතා, මෘදුකාංග පාරංගතය, භාෂා දක්ෂතා සහ වෘත්තීය සහතික ඇතුළත් කරන්න',
    'wizard.experience.notice.title': 'ඉමිග්‍රේෂන් සඳහා අත්දැකීම් වැදගත්',
    'wizard.experience.notice.body': 'දක්ෂ සේවක ඉමිග්‍රේෂන් වැඩසටහන් සඳහා රැකියා අත්දැකීම් අත්‍යවශ්‍යයි. අන්තර්ජාතික අත්දැකීම්, විශේෂ දක්ෂතා සහ පවත්නා රැකියා ඉතිහාසය ඔබගේ සුදුසුකම වැඩි කරයි.',
    'wizard.experience.levels.none': 'නැත',
    'wizard.experience.levels.lt1': 'අවුරුදු 1 ට අඩු',
    'wizard.experience.levels.1to2': 'අවුරුදු 1-2',
    'wizard.experience.levels.3to5': 'අවුරුදු 3-5',
    'wizard.experience.levels.6to10': 'අවුරුදු 6-10',
    'wizard.experience.levels.11to15': 'අවුරුදු 11-15',
    'wizard.experience.levels.16to20': 'අවුරුදු 16-20',
    'wizard.experience.levels.gt20': 'අවුරුදු 20 ට වැඩි',
    'wizard.experience.industries.it': 'තොරතුරු තාක්ෂණය',
    'wizard.experience.industries.healthcare': 'සෞඛ්‍ය සේවා',
    'wizard.experience.industries.engineering': 'ඉංජිනේරු විද්‍යාව',
    'wizard.experience.industries.finance': 'මූල්‍ය & බැංකුකරණය',
    'wizard.experience.industries.education': 'අධ්‍යාපනය',
    'wizard.experience.industries.salesMarketing': 'විකුණුම් & වෙළඳ ප්‍රවර්ධනය',
    'wizard.experience.industries.manufacturing': 'නිෂ්පාදන',
    'wizard.experience.industries.construction': 'ගොඩනැගිලි ක්ෂේත්‍රය',
    'wizard.experience.industries.hospitality': 'සත්කාරක සේවා',
    'wizard.experience.industries.transportation': 'ප්‍රවාහන',
    'wizard.experience.industries.agriculture': 'කෘෂිකර්ම',
    'wizard.experience.industries.government': 'රජය/පොදු අංශය',
    'wizard.experience.industries.consulting': 'උපදේශක සේවා',
    'wizard.experience.industries.realEstate': 'ජංගම දේපළ',
    'wizard.experience.industries.media': 'මාධ්‍ය & සන්නිවේදනය',
    'wizard.experience.industries.other': 'වෙනත්',
    'wizard.experience.jobStatus.employed': 'දැනට රැකියා කරයි',
    'wizard.experience.jobStatus.selfEmployed': 'ස්වයං රැකියා',
    'wizard.experience.jobStatus.unemployed': 'රැකියා රහිත',
    'wizard.experience.jobStatus.student': 'ශිෂ්‍ය',
    'wizard.experience.jobStatus.freelancer': 'නිදහස් වෘත්තිකරු',
    'wizard.experience.jobStatus.businessOwner': 'ව්‍යාපාර හිමිකරු',
    'wizard.experience.jobStatus.retired': 'විශ්‍රාම ගත්',
    'wizard.languageSkills.title': 'භාෂා දක්ෂතා',
    'wizard.languageSkills.description': 'භාෂා දක්ෂතාවය ඉමිග්‍රේෂන් සඳහා අත්‍යවශ්‍ය වන අතර විවිධ වැඩසටහන් සඳහා ඔබගේ සුදුසුකමට දැඩි බලපෑමක් කරයි.',
    'wizard.languageSkills.errors.englishReading.required': 'ඔබගේ ඉංග්‍රීසි කියවීමේ මට්ටම තෝරන්න',
    'wizard.languageSkills.errors.englishWriting.required': 'ඔබගේ ඉංග්‍රීසි ලිවීමේ මට්ටම තෝරන්න',
    'wizard.languageSkills.errors.englishSpeaking.required': 'ඔබගේ ඉංග්‍රීසි කතා කිරීමේ මට්ටම තෝරන්න',
    'wizard.languageSkills.errors.englishListening.required': 'ඔබගේ ඉංග්‍රීසි ශ්‍රවණ මට්ටම තෝරන්න',
    'wizard.languageSkills.errors.hasIELTS.required': 'ඔබට IELTS ප්‍රතිඵල තිබේදැයි සඳහන් කරන්න',
    'wizard.languageSkills.errors.ieltsScore.required': 'ඔබගේ IELTS ලකුණු තෝරන්න',
    'wizard.languageSkills.section.englishProficiency.title': 'ඉංග්‍රීසි භාෂා දක්ෂතා *',
    'wizard.languageSkills.section.tests.title': 'සම්මත පරීක්ෂණ ලකුණු',
    'wizard.languageSkills.fields.englishReading.label': 'කියවීම',
    'wizard.languageSkills.fields.englishReading.placeholder': 'මට්ටම තෝරන්න',
    'wizard.languageSkills.fields.englishWriting.label': 'ලිවීම',
    'wizard.languageSkills.fields.englishWriting.placeholder': 'මට්ටම තෝරන්න',
    'wizard.languageSkills.fields.englishSpeaking.label': 'කතා කිරීම',
    'wizard.languageSkills.fields.englishSpeaking.placeholder': 'මට්ටම තෝරන්න',
    'wizard.languageSkills.fields.englishListening.label': 'සවන් දීම',
    'wizard.languageSkills.fields.englishListening.placeholder': 'මට්ටම තෝරන්න',
    'wizard.languageSkills.fields.hasIELTS.label': 'ඔබට IELTS ප්‍රතිඵල තිබේද? *',
    'wizard.languageSkills.fields.hasIELTS.placeholder': 'IELTS තත්ත්වය තෝරන්න',
    'wizard.languageSkills.fields.hasIELTS.options.yes': 'ඔව්, මට IELTS ප්‍රතිඵල ඇත',
    'wizard.languageSkills.fields.hasIELTS.options.no': 'නැහැ, මට IELTS පරීක්ෂණය කර නොමැත',
    'wizard.languageSkills.fields.hasIELTS.options.planning': 'ඉක්මනින් එය කිරීමට සැලසුම් කරනවා',
    'wizard.languageSkills.fields.ieltsScore.label': 'IELTS සමස්ත ලකුණු *',
    'wizard.languageSkills.fields.ieltsScore.placeholder': 'IELTS ලකුණු තෝරන්න',
    'wizard.languageSkills.fields.ieltsScore.clbHint': '💡 කැනේඩියා ඉමිග්‍රේෂන් සඳහා CLB මට්ටම {{level}} ට සමානයි',
    'wizard.languageSkills.fields.hasTOEFL.label': 'ඔබට TOEFL ප්‍රතිඵල තිබේද? (විකල්පය)',
    'wizard.languageSkills.fields.hasTOEFL.placeholder': 'TOEFL තත්ත්වය තෝරන්න',
    'wizard.languageSkills.fields.hasTOEFL.options.yes': 'ඔව්, මට TOEFL ප්‍රතිඵල ඇත',
    'wizard.languageSkills.fields.hasTOEFL.options.no': 'නැහැ, මට TOEFL පරීක්ෂණය කර නොමැත',
    'wizard.languageSkills.fields.toeflScore.label': 'TOEFL සමස්ත ලකුණු',
    'wizard.languageSkills.fields.toeflScore.placeholder': 'TOEFL ලකුණු තෝරන්න',
    'wizard.languageSkills.fields.otherLanguages.label': 'වෙනත් භාෂාවන් (විකල්පය)',
    'wizard.languageSkills.fields.otherLanguages.placeholder': 'ඔබ දනිවන වෙනත් භාෂා සහ දක්ෂතා මට්ටම් ලැයිස්තුගත කරන්න',
    'wizard.languageSkills.fields.otherLanguages.helper': 'ප්‍රංෂ, ජර්මන්, ස්පාඤ්ඤ වැනි ඉමිග්‍රේෂන් සඳහා ප්‍රයෝජනවත් භාෂා ඇතුළත් කරන්න',
    'wizard.languageSkills.notice.title': 'ඉමිග්‍රේෂන් සඳහා භාෂා අවශ්‍යතා',
    'wizard.languageSkills.notice.body': 'බොහෝ ඉමිග්‍රේෂන් වැඩසටහන් සඳහා අවම භාෂා දක්ෂතාවය අවශ්‍යයි. IELTS වැනි සාමාන්‍ය පරීක්ෂණ ලකුණු බොහෝවිට අත්‍යවශ්‍ය වන අතර ඔබගේ ලකුණු ගණනයට සෘජුව බලපායි.',
    'wizard.languageSkills.levels.beginner': 'ආරම්භික (A1-A2)',
    'wizard.languageSkills.levels.intermediate': 'මධ්‍යස්ථ (B1-B2)',
    'wizard.languageSkills.levels.advanced': 'උසස් (C1)',
    'wizard.languageSkills.levels.native': 'දේශීය/සම්පූර්ණ දක්ෂ (C2)',
    'wizard.languageSkills.ielts.4_0_4_5': '4.0 - 4.5 (සීමිත)',
    'wizard.languageSkills.ielts.5_0_5_5': '5.0 - 5.5 (මධ්‍යම)',
    'wizard.languageSkills.ielts.6_0_6_5': '6.0 - 6.5 (සුදුසු)',
    'wizard.languageSkills.ielts.7_0_7_5': '7.0 - 7.5 (හොඳ)',
    'wizard.languageSkills.ielts.8_0_8_5': '8.0 - 8.5 (ඉතා හොඳ)',
    'wizard.languageSkills.ielts.9_0': '9.0 (විශේෂඥ)',
    'wizard.languageSkills.toefl.0_30': '0-30 (සීමිත)',
    'wizard.languageSkills.toefl.31_50': '31-50 (අඩු මධ්‍යස්ථ)',
    'wizard.languageSkills.toefl.51_70': '51-70 (මධ්‍යස්ථ)',
    'wizard.languageSkills.toefl.71_90': '71-90 (උසස් මධ්‍යස්ථ)',
    'wizard.languageSkills.toefl.91_100': '91-100 (උසස්)',
    'wizard.languageSkills.toefl.101_120': '101-120 (විශේෂඥ)',
    'wizard.financialInfo.title': 'අධ්‍යාපන අයවැය',
    'wizard.financialInfo.description': 'ඔබට තිබෙන අධ්‍යාපන අයවැය අවබෝධ කරගැනීම අපට සුදුසු ඉමිග්‍රේෂන් මාර්ග සහ මූල්‍ය විකල්ප නිර්දේශ කිරීමට උපකාරී වේ.',
    'wizard.financialInfo.errors.educationBudget.required': 'ඔබගේ අධ්‍යාපන අයවැය තෝරන්න',
    'wizard.financialInfo.fields.currency.label': 'ඔබ කැමති මුදල් ඒකකය',
    'wizard.financialInfo.fields.educationBudget.label': 'පවතින අධ්‍යාපන අයවැය *',
    'wizard.financialInfo.fields.educationBudget.placeholder': 'ඔබගේ අයවැය තෝරන්න',
    'wizard.financialInfo.fields.financialNotes.label': 'අමතර මූල්‍ය සටහන් (විකල්පය)',
    'wizard.financialInfo.fields.financialNotes.placeholder': 'ඔබගේ මූල්‍ය තත්ත්වය, ශිෂ්‍යත්ව හෝ මූල්‍ය ආරංචි මාර්ග පිළිබඳ තොරතුරු',
    'wizard.financialInfo.fields.financialNotes.helper': 'ශිෂ්‍යත්ව, පවුල් සහයෝගය හෝ වෙනත් මූල්‍ය සැලසුම් ඇත්නම් අවධාරණය කරන්න',
    'wizard.financialInfo.notice.title': 'ඔබගේ අයවැය ඇයි වැදගත්',
    'wizard.financialInfo.notice.body': 'ඔබගේ අධ්‍යාපන අයවැය අපට සුදුසු ඉමිග්‍රේෂන් මාර්ග සලස්වීමට උපකාරී වේ. රට අනුව විවිධ පිරිවැය තිබේ: ජර්මනියට අවහිර ගිණුමක් ({{symbol}}13,080/වසර) අවශ්‍යයි, කැනඩාවට මූල්‍ය සාධක අවශ්‍යයි, සහ අධ්‍යාපන ගාස්තු විශාල ලෙස වෙනස් විය හැක.',
    'wizard.financialInfo.currencies.usd': 'USD - ඇමරිකන් ඩොලර්',
    'wizard.financialInfo.currencies.eur': 'EUR - යුරෝ',
    'wizard.financialInfo.currencies.gbp': 'GBP - බ්‍රිතාන්‍ය පවුම්',
    'wizard.financialInfo.currencies.cad': 'CAD - කැනේඩියානු ඩොලර්',
    'wizard.financialInfo.currencies.aud': 'AUD - ඔස්ට්‍රේලියානු ඩොලර්',
    'wizard.financialInfo.currencies.lkr': 'LKR - ලංකා රුපියල්',
    'wizard.financialInfo.currencies.inr': 'INR - ඉන්දියානු රුපියල්',
    'wizard.financialInfo.budgets.0_10000': '$10,000 ට අඩු',
    'wizard.financialInfo.budgets.10000_25000': '$10,000 - $25,000',
    'wizard.financialInfo.budgets.25000_50000': '$25,000 - $50,000',
    'wizard.financialInfo.budgets.50000_75000': '$50,000 - $75,000',
    'wizard.financialInfo.budgets.75000_plus': '$75,000 ට වැඩි',
    'wizard.review.recommendations.title': 'නිර්දේශිත ඉමිග්‍රේෂන් විකල්ප',
    'wizard.review.proceedButton': 'අවසාන පියවරට යන්න',
    'wizard.submit.title': 'ඔබගේ පැතිකඩ ඉදිරිපත් කරන්න',
    'wizard.submit.description': 'අපගේ විශේෂඥයින්ගෙන් පෞද්ගලික ඉමිග්‍රේෂන් නිර්දේශ ලබා ගැනීමට ඔබගේ සම්පූර්ණ පැතිකඩ ඉදිරිපත් කරන්න.',
    'wizard.submit.errors.agreeToTerms': 'ඉදිරියට යාමට නීති සහ කොන්දේසි අනුමත කරන්න.',
    'wizard.submit.actions.submitting': 'ඉදිරිපත් කරමින්...',
    'wizard.submit.actions.submitForReview': 'සමාලෝචනය සඳහා පැතිකඩ ඉදිරිපත් කරන්න',
    'wizard.dynamic.title': 'අමතර ප්රශ්න',
    'wizard.dynamic.subtitle': 'ඔබට පෞද්ගලික උපදෙස් ලබාදීමට මෙම ප්රශ්න උපකාරී වේ.',
    'wizard.dynamic.radioGroupLabel': 'විකල්ප තේරීම්',
    'wizard.dynamic.questions.ielts_status.question': 'ඔබගේ IELTS තත්ත්වය කුමක්ද?',
    'wizard.dynamic.questions.ielts_status.options.have_6_0': '6.0+ ලකුණු ඇත',
    'wizard.dynamic.questions.ielts_status.options.taking_soon': 'ඉක්මනින් ලියන්න සූදානම්',
    'wizard.dynamic.questions.ielts_status.options.not_started': 'තවම ආරම්භ කර නැහැ',
    'wizard.dynamic.questions.ielts_status.options.need_help': 'උදව් අවශ්‍යයි',
    'wizard.dynamic.questions.al_results.question': 'ඔබගේ A/L ප්‍රතිඵල මොනවාද?',
    'wizard.dynamic.questions.al_results.options.3_passes': 'විෂය 3ක් සමත්',
    'wizard.dynamic.questions.al_results.options.2_passes': 'විෂය 2ක් සමත්',
    'wizard.dynamic.questions.al_results.options.1_pass': 'විෂය 1ක් සමත්',
    'wizard.dynamic.questions.al_results.options.still_waiting': 'ප්‍රතිඵලයට තවම බලා සිටිනවා',
    'wizard.dynamic.questions.program_interest.question': 'ඔබට කැමති පාඨමාලාව මොකක්ද?',
    'wizard.dynamic.questions.program_interest.options.1_year_pg_certificate': 'වසර 1 පශ්චාත් උපාධි සහතිකය',
    'wizard.dynamic.questions.program_interest.options.2_year_pg_diploma': 'වසර 2 පශ්චාත් උපාධි ඩිප්ලෝමා',
    'wizard.dynamic.questions.program_interest.options.certificate': 'සහතිකය',
    'wizard.dynamic.questions.program_interest.options.diploma': 'ඩිප්ලෝමා',
    'wizard.dynamic.questions.program_interest.options.bachelor_master': 'බැචලර්/මාස්ටර්',
    'wizard.dynamic.questions.program_interest.options.need_guidance': 'මඟපෙන්වීම අවශ්‍යයි',
    'wizard.dynamic.questions.program_interest.options.bachelor_s_degree': 'බැචලර් උපාධිය',
    'wizard.dynamic.questions.program_interest.options.master_s_degree': 'මාස්ටර්ස් උපාධිය',
    'wizard.dynamic.questions.program_interest.options.graduate_diploma': 'උපාධිධාරී ඩිප්ලෝමා',
    'wizard.dynamic.questions.program_interest.options.vocational_education': 'වෘත්තීය අධ්‍යාපනය',
    'wizard.dynamic.questions.program_interest.options.phd': 'පීඑච්ඩී',
    'wizard.dynamic.questions.program_interest.options.foundation_course': 'මූලික පාඨමාලාව',
    'wizard.dynamic.questions.program_interest.options.associate_degree': 'සහකාර උපාධිය',
    'wizard.financial.title': '{{country}} සදහා මූල්‍ය තොරතුරු',
    'wizard.financial.subtitle': 'සම්පූර්ණ වැය හා මූල්‍ය අවශ්‍යතා',
    'wizard.financial.tipTitle': 'ඉඟිය:',
    'wizard.financial.tipBody': 'මෙය ඇස්තමේන්තු පමණක්. ඔබගේ තත්ත්වය අනුව සංඛ්‍යා වෙනස් විය හැක.',
    'wizard.financial.titles.blockedAccount': 'අවශ්‍ය බැඳීම් ගිණුම',
    'wizard.financial.titles.sponsorSavings': 'අනුග්රාහක ප්රතිලාභ',
    'wizard.financial.titles.tuition': 'ටියුෂන් ගාස්තු',
    'wizard.financial.titles.loanOption': 'ගෙවීමේ විකල්ප',
    'wizard.financial.titles.costs': 'ඇස්තමේන්තුගත වියදම්',
    'wizard.financial.titles.workPermit': 'කම්කරු අයිතිවාසිකම්',
    'wizard.financial.titles.workRights': 'කම්කරු අයිතිවාසිකම්',
    'wizard.financial.titles.postStudy': 'ඉදිරි අවස්ථා',
    'wizard.financial.titles.guidance': 'අපේ උපදෙස්',
    'wizard.financial.titles.comparison': 'සසඳන සේවාව',
    'wizard.financial.titles.support': 'සහාය',
    'wizard.financial.titles.budgetRange': 'මිල අලවට සැලසුම',
    'wizard.submit.finalStep': 'අවසාන පියවර',
    'wizard.insights.progress': 'ප්‍රගතිය',
    'wizard.insights.complete': 'සම්පූර්ණයි',
    'wizard.insights.mobileToggleTitle': 'ක්‍රමවත් මඟපෙන්වීම',
    'wizard.insights.expand': 'විහිදුවන්න',
    'wizard.insights.collapse': 'අවදානම්',
    'wizard.insights.fastTipTitle': 'ක්ෂණික උපදෙස්',
    'wizard.insights.fastTipBody': 'වීසාඩයයි එකම අවස්ථාවක අවසන් කරන්න. ඉදිරි 48 පැය තුළ ඔබට උපදේශන කාලසටහනක් ලැබීමට හැක.',
    'wizard.insights.snapshotTitle': 'ඔබ සංග්‍රහය',
    'wizard.insights.snapshot.notSelected': 'තෝරා නැත',
    'wizard.insights.snapshot.destination': 'රට තේරීම',
    'wizard.insights.snapshot.applicant': 'අයදුම්කරු',
    'wizard.insights.snapshot.education': 'උසස් අධ්‍යාපනය',
    'wizard.insights.snapshot.experience': 'අත්දැකීම් අවුරුදු',
    'wizard.insights.snapshot.years': 'අවුරුදු',
    'wizard.insights.snapshot.language': 'භාෂා තත්ත්වය',
    'wizard.insights.nextTitle': 'ඊළඟට',
    'wizard.insights.nextDescription': '{{title}} පිළිබඳව ගැඹුරු සලකා බලන්න',
    'consult.chat.initialPrompt': 'හෙලෝ! මම ඔබගේ AI විදේශගත උපදේශකයා. ආරම්භ කිරීමට පෙර, මෙම සංවාදය සඳහා ඔබ කැමති භාෂාව කුමක්ද? (English / Tamil / Sinhala)',
    'consult.chat.resetPrompt': 'නැවත හෙලෝ! අද ඔබ භාවිතා කිරීමට කැමති භාෂාව කුමක්ද? (English / Tamil / Sinhala)',
    // Choice Page
    'choice.title': 'අද අපට ඔබට උපකාර කළ හැක්කේ කෙසේද?',
    'choice.subtitle': 'ඔබගේ වර්තමාන අවශ්‍යතා සඳහා වඩාත් ගැලපෙන මාර්ගය තෝරන්න. සියලු මාර්ග ඔබගේ විදේශ අධ්‍යාපන සිහිනය කරා ගමන් කරයි!',
    'choice.option1.icon': '🎯',
    'choice.option1.title': 'මට හොඳම විකල්පය සොයා ගන්න',
    'choice.option1.description': 'ඔබට වඩාත් ගැලපෙන රට හෝ වැඩසටහන කුමක්දැයි විශ්වාස නැද්ද? ඔබගේ පැතිකඩ, අයවැය සහ ඉලක්ක මත පදනම්ව පුද්ගලීකරණය කළ නිර්දේශ ලබා ගැනීමට අපගේ ස්මාර්ට් තක්සේරුව කරන්න.',
    'choice.option1.feature1': 'AI-බලගන්වන රට ගැලපීම',
    'choice.option1.feature2': 'අයවැය විශ්ලේෂණය සහ සැලසුම්කරණය',
    'choice.option1.feature3': 'වෘත්තීය මාර්ග නිර්දේශ',
    'choice.option1.feature4': 'ක්ෂණික සුදුසුකම් පරීක්ෂාව',
    'choice.option1.cta': 'නොමිලේ තක්සේරුව ආරම්භ කරන්න',
    'choice.option1.badge': 'නිර්දේශිත',
    'choice.option2.icon': '💬',
    'choice.option2.title': 'මට අවශ්‍ය දේ මම දනිමි - විශේෂඥයා සමඟ කතා කරන්න',
    'choice.option2.description': 'ඔබගේ ගමනාන්තය සහ වැඩසටහන දැනටමත් තීරණය කර තිබේද? පුද්ගලීකරණය කළ මඟ පෙන්වීම සඳහා අපගේ සංක්‍රමණ විශේෂඥයන් සමඟ කෙලින්ම සම්බන්ධ වී ඔබගේ අයදුම් ක්‍රියාවලිය වේගවත් කරන්න.',
    'choice.option2.feature1': 'සෘජු විශේෂඥ උපදේශන',
    'choice.option2.feature2': 'අයදුම්පත වේගවත් කිරීම',
    'choice.option2.feature3': 'ලේඛන සකස් කිරීමේ උපකාර',
    'choice.option2.feature4': 'වීසා සම්මුඛ පරීක්ෂණ පුහුණුව',
    'choice.option2.cta': 'දැන් විශේෂඥයා සම්බන්ධ කර ගන්න',
    'choice.option3.icon': '📚',
    'choice.option3.title': 'මට තොරතුරු පමණක් අවශ්‍යයි',
    'choice.option3.description': 'ඔබගේ විකල්ප ගවේෂණය කර තව දැනගැනීමට අවශ්‍යද? සියලුම රටවල් 5 සඳහා වැඩසටහන්, පිරිවැය, අවශ්‍යතා සහ ක්‍රියාවලීන් පිළිබඳ ක්ෂණික පිළිතුරු ලබා ගැනීමට අපගේ AI සහායක සමඟ කතාබස් කරන්න.',
    'choice.option3.feature1': '24/7 AI සහායක ලබා ගත හැක',
    'choice.option3.feature2': 'නිතර අසන පැන සඳහා ක්ෂණික පිළිතුරු',
    'choice.option3.feature3': 'වැඩසටහන් සංසන්දනය',
    'choice.option3.feature4': 'වියදම් බිඳවැටීම',
    'choice.option3.cta': 'AI සහායක සමඟ කතාබස් කරන්න',
    'choice.trust.title': 'සිසුන් 1000+ රවාන මයිග්‍රේෂන් විශ්වාස කරන්නේ ඇයි?',
    'choice.trust.stat1.value': '99%',
    'choice.trust.stat1.label': 'සාර්ථක අනුපාතය',
    'choice.trust.stat2.value': '5',
    'choice.trust.stat2.label': 'රටවල්',
    'choice.trust.stat3.value': '7+',
    'choice.trust.stat3.label': 'වසර අත්දැකීම්',
    'choice.trust.stat4.value': '1000+',
    'choice.trust.stat4.label': 'උදව් කළ සිසුන්',
    'choice.trust.stat5.value': '100%',
    'choice.trust.stat5.label': 'විනිවිද පෙනෙන',
    'choice.help.text': 'තවමත් ඔබට සුදුසු විකල්පය කුමක්දැයි විශ්වාස නැද්ද?',
    'choice.help.link1': 'අප ගැන වැඩි විස්තර',
    'choice.help.link2': 'අපගේ පැකේජ බලන්න',
    'choice.help.link3': 'සේවාවන් ගවේෂණය කරන්න',
    // Home Page
    'home.ravana.global.track.title': 'රවාන ගෝලීය ට්‍රැක්™ — එක් අයදුම්පත්. පසුම්බි ස්ථාන 5.',
    'home.ravana.global.track.subtitle': 'එක් හවුල්කරු. රටවල් 5. අනන්ත විභවාත්මක අවස්ථා.',
    'home.ravana.global.track.description': 'ජර්මනිය, කැනඩාව, ඔස්ට්‍රේලියාව, එක්සත් රාජධානිය සහ නیواڈی لینڈ පුරා විසින් වීසා සහ සංක්‍රමණ සේවා.',
    'home.hero.tagline': 'විදේශයන්හි අධ්‍යයන, රැකියා සහ ස්ථාපනය — එක් හවුල්කරු. රටවල් 5.',
    'home.why.choose.title': 'රවාන සංක්‍රමණය මින් පෙර තෝරා ගත යුත්තේ ඇයි?',
    'home.cta.journey': 'ඔබේ ගමන ආරම්භ කිරීමට සූදානම්ද?',
    'home.cta.chat.expert': 'විශේෂඥයා සමඟ කතා කරන්න',
    'home.cta.start.assessment': 'නොමිලේ ඇගයීමක් ආරම්භ කරන්න',
    // Services Page
    'services.hero.title': 'රවාන ගෝලීය ට්‍රැක්™ සේවා',
    'services.hero.subtitle': 'එක් හවුල්කරු. රටවල් 5. අනන්ත විභවාත්මක අවස්ථා.',
    'services.hero.description': 'ජර්මනිය, කැනඩාව, ඔස්ට්‍රේලියාව, එක්සත් රාජධානිය සහ නیواڈی لینڈ පුරා විසින් වීසා සහ සංක්‍රමණ සේවා.',
    'services.why.choose.title': 'අපේ සේවා මින් පෙර තෝරා ගත යුත්තේ ඇයි?',
    'services.why.choose.subtitle': 'ලොව පුරා සිටින සිසුන් අපේක්ෂා කරන ලද',
    'services.additional.title': ' дополнителна සහාය සේවා',
    'services.additional.subtitle': 'අපගේ සියලුම පැකේජ සඳහා ඇතුළත් වූ විස්තීර්ණ සහාය සේවා',
    'services.cta.journey': 'ඔබේ ගමන ආරම්භ කිරීමට සූදානම්ද?',
    'services.cta.contact': 'අප අමතන්න',
    // About Page
    'about.cta.journey': 'ඔබේ ගමන ආරම්භ කිරීමට සූදානම්ද?',
    'about.cta.consultation': 'නොමිලේ උපදේශ මේට්ටුවක් සකස් කරන්න',
    // Global Branding
    'global.tagline': 'එක් අයදුම්පත. ස්ථාන 5. එක් ගෝලීය හවුල්කරු.',
    'global.track.name': 'රවාන ගෝලීය ට්‍රැක්™',
    'global.countries': 'ජර්මනිය • කැනඩාව • ඔස්ට්‍රේලියාව • එක්සත් රාජධානිය • නیواڈی لینڈ',
    // Country Names
    'country.germany': 'ජර්මනිය',
    'country.canada': 'කැනඩාව',
    'country.australia': 'ඔස්ට්‍රේලියාව',
    'country.uk': 'එක්සත් රාජධානිය',
    'country.newzealand': 'නیواڈی لینڈ',
    // Common Actions
    'common.get.started': 'ආරම්භ කරන්න',
    'common.learn.more': 'තවත් ඉගෙන ගන්න',
    'common.contact.us': 'අප අමතන්න',
    'common.book.consultation': 'උපදේශ මේට්ටුවක් සකස් කරන්න',
    'common.start.assessment': 'ඇගයීම ආරම්භ කරන්න',
    'common.chat.expert': 'විශේෂඥයා සමඟ කතා කරන්න'
  }
};
